/* kit-match-ab.js — v15.6 2026-09-28 (drawer: Original «−30 %» pill and promo line hidden while a lens/kit is already in the package)
 * v15.8 2026-10-01 (product JSON fetched without cookies: a USD cart made /no-no/products/*.js answer in USD — the real cause of the "−1 169 kr / −860 kr" kit rows; the cart itself is repaired by cart-route-shim)
 * v15.7 2026-10-01 (market root resolved once from the URL path; failed product fetches retry — fixes a USD kit price shown as NOK on /no-no/: "−1 169 kr")
 * v15.5 2026-09-28 (drawer shows 15 % only while no spare lens is chosen yet)
 * v15.4 2026-09-28 (kit on = no spare-lens discount anywhere: rows, chooser, theme drawer preview; the kit already used the one discounted lens)
 * v15.3 2026-09-28 (nosepad row from the lens drawer shows the chosen colour + its image and gets its own Remove)
 * v15.2 2026-09-28 (drawer picks: the same lens added again is a second lens, not a replacement; several nosepads are all counted in the total, as the cart charges them)
 * v15.0 2026-09-24 (Sharp kits: alts/rxAlts = same kit with another $39 spare-lens colour; first in stock is sold; Essential Cyclist Right added)
 * v12.3 2026-09-02 (Elevate test 2dacb1d0 'Din pakke on The View PDP': Control 52300=A, Variation 1 52301=B)
 * v12.2 2026-09-02 (initGroup: a late window.__triKitABForce from Elevate's variation JS is honoured during the poll window; test ids no longer required)
 * v12.1 2026-09-02 (code-review fixes: rx state reset on kit change, ATC swap re-entry guard, rx only when purchasable, no kit before prices load, honest compare-at, build snapshot hygiene)
 * v14.6 2026-09-04 (Clip complete: every variant has a kit)
 * v14.5 2026-09-04 (all Clip Sharp S kits)
 * v14.4 2026-09-04 (3 more small Clip kits)
 * v14.3 2026-09-04 (Clip kits save 10; small kits ship white neckwear)
 * v14.2 2026-09-04 (missing IMG keys; kits ship the Large mirror, not Medium)
 * v14.1 2026-09-04 (10 Clip kits)
 * v14.0 2026-09-04 (The Clip: own state shape, own anchor, kits scoped per product)
 * v13.1 2026-09-04 (S·140 kits label their mirror Medium)
 * v13.0 2026-09-04 (6 S·140 kits; photochromic kits no longer ship a Clear lens)
 * v12.8 2026-09-03 (fr: Passez à)
 * v12.7 2026-09-03 (German keeps noun capitalisation)
 * v12.6 2026-09-03 (de/fr/it/es added: module was English on non-EN, non-NO markets)
 * v12.5 2026-09-03 (kit JSON fetched on demand: 3 core requests instead of 40, first paint no longer blocked)
 * v12.4 2026-09-03 (kits are only offered when the kit variant is in stock — availability now stored in PRICES)
 * v12.0 2026-09-02 (15 Original kits in KITS; kit shown only when its product is published; kits without an Rx twin hide the Rx toggle)
 * v11.2 2026-09-02 (mirror-free copy: car and every day)
 * v11.1 2026-09-02 (mirror rows: mirror's own name + image, fit text: glasses / spare lens / both)
 * v11.0 2026-09-02 (+Reserveglass opens the theme's own lens drawer (it carries the larger-mirror choice for Original lenses); drawer picks accumulate as separate lenses; accessories button names the larger mirror)
 * v10.2 2026-09-02 (kit box: only the switch turns the kit OFF; a click anywhere turns it on)
 * v10.1 2026-09-02 (kit nosepad copy; size change clears spare lenses + accessories)
 * v10.0 2026-09-02  Several spare lenses (first one discounted, as the cart does); chooser patches in place (no module re-render on pick); mirror box fixed height; kit contents as rows (variant 1).
 * v9.0 2026-09-02  Variant A "Ren kvittering": list holds only what is in the package (no check marks); kit is a switch box under the list; add-links are two buttons; total is a dark band.
 * v8.3 2026-09-02 (prescription insert follows the frame colour; row labelled Innsatsramme)
 * v8.2 2026-09-02 (mirror box always shown w/ 3 states; section gets a solid frame; .s renamed - theme strikes `s, .s`)
 * v8.0 2026-09-02  "Din pakke": ONE visible list (glasses, kit as +delta, added lens/accessories as rows, total), six-lens chooser (Sharp/Original, size-filtered, mirror option), confirmation motion. Control untouched.
 * v7.2 2026-09-02 (build panel: re-capture theme rows on every repaint; struck subtotal + savings row follow kit totals)
 * v7.1 2026-09-02 (kit + spare lens/accessories: theme's own atomic POST; totals = kit + extras)
 * v7.0 2026-09-02  "Kit-valget" (v7: 5-persona virtual user test + council)
 * v7 changes: kit row names its contents up front (no vague tagline); every
 * component carries a one-line WHY; spare lens + accessories are ONE quiet
 * text line INSIDE the module above Add-to-Cart (not a stranded box after the
 * trust badges), always visible (kit + own lens is a real path); configs
 * without a kit still get the same module (heading + extras line) so arm B is
 * one coherent experience; Rx toggle explains what the insert is.
 * A/B test. Group A = control (default PDP) — UNTOUCHED, gated by `GROUP !== 'B'`.
 * Group B (this file's render layer, rebuilt 2026-09-02 after the v5 arm B
 * produced 0 kit orders in 7 days):
 *   1. "Glasses only" is the DEFAULT. v5 preselected the kit and hijacked the
 *      Add-to-Cart click, silently swapping the configured $99 glasses for a
 *      $149 kit — 4 of 4 kit checkouts were abandoned. The button now does
 *      what the selected row says, and the row defaults to what the customer
 *      configured.
 *   2. Two rows, styled as the theme's own .nosepad-option (flat, 8px radius,
 *      no shadow), under the theme's own "Make it yours (optional)" heading.
 *      The kit row expands to a strip of the real component photos.
 *   3. Prescription is an inline toggle INSIDE the kit row (swaps the nosepad
 *      set for the insert frame), not a third competing card.
 *   4. The spare lens is a DOWNSELL, not a sibling: a quiet row under the
 *      Add-to-Cart that opens the theme's own lens drawer, shown only while
 *      "Glasses only" is selected (the kit already contains a lens). A second
 *      row opens the accessories drawer, so no control path is lost.
 *   5. Exposure is logged once per page (tri_kit_module_exposure) so the next
 *      test can measure against visitors who actually SAW the module — v5
 *      only fired on the small Sharp/M·145 subset and measured against everyone.
 * Measurement: dataLayer tri_kit_match_ab/_view/_select/_click/_exposure (+ab_group);
 * attribution: cart attribute _kit_ab (both arms) + the kit product itself; no per-line _ref since v7.2 (the theme's own POST builds the lines).
 * Measurement: dataLayer tri_kit_match_ab/_view/_select/_click (+ab_group);
 * kit orders carry line-item property _ref = pdp-kit-match.
 * Reads the configurator's global lexical `state` {lens,color,size,mirror};
 * guarded against TDZ, hooks in only after window.updateConfig exists.
 */
(function () {
  var CDN = 'https://cdn.shopify.com/s/files/1/0555/9808/8235/files/';
  var IMG = {
    blue: CDN + '7090048762377-W.jpg?width=160',
    gold: CDN + '7090048762407-W.jpg?width=160',
    purple: CDN + '7090048762438-W.jpg?width=160',
    nose: CDN + 'extra-nosepad-for-trieye-view-models-416544.png?width=160',
    nwBW: CDN + 'nw_Black_white_1.jpg?width=160',
    nwWB: CDN + 'nw_White_black_-_2.jpg?width=160',
    nwRB: CDN + 'nw_Red_black_1.jpg?width=160',
    nwOB: CDN + 'trieye-neckwear-866542.png?width=160',
    flt:  CDN + 'float-retainer-studio.jpg?width=160',
    hc:   CDN + 'lens-hc-sharp.jpg?width=160',
    yellowL: 'https://cdn.shopify.com/s/files/1/0555/9808/8235/files/yellow_left.png?width=160',
    yellowR: 'https://cdn.shopify.com/s/files/1/0555/9808/8235/files/yellow_right.png?width=160',
    clearL: 'https://cdn.shopify.com/s/files/1/0555/9808/8235/files/view-extra-lens-FINAL-clear.png?width=160',
    clearR: 'https://cdn.shopify.com/s/files/1/0555/9808/8235/files/right-v2-lens-clear.png?width=160',
    clearD: 'https://cdn.shopify.com/s/files/1/0555/9808/8235/files/clear_dual.png?width=160',
    polD: 'https://cdn.shopify.com/s/files/1/0555/9808/8235/files/polarized_dual_v2.png?width=160',
    blueD: 'https://cdn.shopify.com/s/files/1/0555/9808/8235/files/blue_dual.png?width=160',
    mirL: 'https://cdn.shopify.com/s/files/1/0555/9808/8235/files/trieye-view-sport-replacement-mirror-4706847.png?width=160',
    /* same photos as mirL/mirR — separate keys only so The Clip's mirror row
       can say what it is there: a wider spare mirror, not one for a spare lens.
       The query suffix only makes the strings differ — partInfo matches on the
       exact src, so identical URLs would fall through to the View wording. */
    mirLc: 'https://cdn.shopify.com/s/files/1/0555/9808/8235/files/trieye-view-sport-replacement-mirror-4706847.png?width=160&for=clip',
    mirRc: 'https://cdn.shopify.com/s/files/1/0555/9808/8235/files/trieye-view-sport-replacement-mirror-6546293.png?width=160&for=clip',
    mirR: 'https://cdn.shopify.com/s/files/1/0555/9808/8235/files/trieye-view-sport-replacement-mirror-6546293.png?width=160'
  };
  var RX = {
    img: 'https://cdn.shopify.com/s/files/1/0555/9808/8235/files/prescription-insert-frame-803261.jpg?width=160'
  };
  var CORE = ['the-view', 'the-view-spare-lens', 'view-sport-replacement-mirror', 'nosepad'];
  /* kit handles are derived from KITS[].handle and fetched on demand; kept here
     only as the full list of kit products this module can offer */
  var KIT_HANDLES = [
    'high-contrast-cyclist-kit-left', 'high-contrast-cyclist-kit-right', 'polarized-original-cyclist-kit-left', 'polarized-original-cyclist-kit-right', 'photochromic-cyclist-kit-left', 'photochromic-cyclist-kit-right', 'reflective-red-cyclist-kit-left', 'reflective-red-cyclist-kit-right', 'reflective-blue-original-cyclist-kit-left', 'reflective-blue-original-cyclist-kit-right', 'photochromic-0-2-cyclist-kit-left', 'photochromic-0-2-cyclist-kit-right', 'standard-clear-rowing-kit', 'reflective-blue-original-rowing-kit', 'photochromic-0-2-rowing-kit',
    'essential-cyclist-kit', 'essential-cyclist-kit-prescription',
    'performance-cyclist-kit', 'performance-cyclist-kit-prescription',
    'essential-rowing-kit', 'essential-rowing-kit-prescription',
    'performance-rowing-kit', 'performance-rowing-kit-prescription',
    'reflective-gold-cyclist-kit', 'reflective-gold-cyclist-kit-prescription',
    'reflective-gold-rowing-kit', 'reflective-gold-rowing-kit-prescription',
    'reflective-purple-cyclist-kit', 'reflective-purple-cyclist-kit-prescription',
    'reflective-purple-rowing-kit', 'reflective-purple-rowing-kit-prescription',
    'reflective-blue-cyclist-kit', 'reflective-blue-cyclist-kit-prescription',
    'polarized-rowing-kit', 'polarized-rowing-kit-prescription',
    'polarized-cyclist-kit', 'polarized-cyclist-kit-prescription'];
  /* product JSON is fetched under the market root (e.g. /no-no/) so prices come
     back already in the visitor's market currency with the market's rounding —
     the theme shows "204 kr" for the $19 lens, and so do we */
  /* v15.7: the root is resolved ONCE, from the URL path first. 2026-10-01 a Norwegian
     visitor saw "Oppgrader til ... kit −1 169 kr": the glasses came from /no-no/ (NOK)
     while the kit JSON, fetched later on demand, came from / (USD) — so Shopify.routes
     was not reliable at that moment (in-app browser / third-party script). Mixing
     roots between fetches is what produced the negative delta; one cached root makes
     every fetch, early or late, use the same market. */
  var ROOT = null;
  function marketRoot() {
    if (ROOT) return ROOT;
    var r = '';
    try { var m = String(location.pathname || '').match(/^\/[a-z]{2}-[a-z]{2}(?=\/|$)/i); if (m) r = m[0] + '/'; } catch (e) {}
    if (!r) { try { r = (window.theme && window.theme.routes && window.theme.routes.root_url) || ''; } catch (e) {} }
    if (!r) { try { r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || ''; } catch (e) {} }
    if (!r) r = '/';
    if (r.charAt(r.length - 1) !== '/') r += '/';
    ROOT = r;
    return ROOT;
  }
  var PRICES = {};       /* variantId -> {p: price cents, c: compare-at cents} in the MARKET currency */
  var LENSMIN = 0;       /* cheapest available mirror-free (W/O) spare lens, market cents */
  var LENSPROD = null, MIRPROD = null, NOSEPROD = null;   /* full product JSON (market prices) for the chooser / rows */
  var pricesLoaded = false;
  var fetched = {};      /* handle -> true once its request has been started */
  function absorb(h, p) {
    if (!p) return;
    if (window.__triRA && p.variants) window.__triRA(p.variants);   /* 2026-10-09: region-blocked variants (trieye.ship_countries) read as unavailable */
    if (h === 'the-view-spare-lens') LENSPROD = p;
    if (h === 'view-sport-replacement-mirror') MIRPROD = p;
    if (h === 'nosepad') NOSEPROD = p;
    if (!p.variants) return;
    p.variants.forEach(function (v) {
      PRICES[v.id] = { p: v.price, c: v.compare_at_price || 0, a: v.available !== false };
      if (h === 'the-view-spare-lens' && v.available && /W\/O/i.test(v.title || '')) {
        if (!LENSMIN || v.price < LENSMIN) LENSMIN = v.price;
      }
    });
  }
  function fetchProduct(h, done) {
    if (fetched[h]) return;
    fetched[h] = true;
    /* v15.8: no cookies. With a cart that a root-path page view flipped to USD, Shopify
       answers /no-no/products/*.js in the CART's currency; without cookies the path decides. */
    fetch(marketRoot() + 'products/' + h + '.js', { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p) absorb(h, p); else fetched[h] = false; })   /* v15.7: a failed fetch may be retried */
      .catch(function () { fetched[h] = false; })
      .then(function () { if (done) done(); });
  }
  /* Kit prices are fetched only for the kit the current build actually matches,
     plus its prescription twin. Loading all 37 kit products up front cost ~85 kB
     and held the first paint until the slowest of 40 requests came back. */
  function ensureKit(k) {
    if (!k) return;
    var hs = [k.handle];
    if (k.rxVariant) hs.push(k.handle + '-prescription');
    hs.forEach(function (h) {
      fetchProduct(h, function () { try { render(); setAtcLabel(); } catch (e) {} });
    });
  }
  function loadPrices() {
    var left = CORE.length;
    /* start the matching kit in parallel with the core products, so the upgrade
       box is there on the first paint instead of popping in after it */
    try { ensureKit(kitRule(readState())); } catch (e) {}
    CORE.forEach(function (h) {
      fetchProduct(h, function () {
        left--;
        if (left === 0) {
          pricesLoaded = true;
          try { render(); startBuildObserver(); setAtcLabel(); } catch (e) {}
        }
      });
    });
  }
  function kitCents(vid, fallbackNum) {
    var e = PRICES[vid];
    return Math.round((e ? e.p : fallbackNum * 100) * fxRatio());
  }
  function kitCompareCents(vid, fallbackNum) {
    var e = PRICES[vid];
    if (e) return Math.round((e.c || 0) * fxRatio());
    return Math.round(fallbackNum * 100 * fxRatio());
  }
  var KITIMG = {
    'essential-cyclist-kit': CDN + 'kit-flatlay-essential-cyclist.png',
    'performance-cyclist-kit': CDN + 'kit-flatlay-performance-cyclist-gold.png',
    'essential-rowing-kit': CDN + 'kit-flatlay-essential-rowing-blue.png',
    'performance-rowing-kit': CDN + 'kit-flatlay-performance-rowing.png',
    'reflective-gold-cyclist-kit': CDN + 'kit-flatlay-reflective-gold-cyclist-kit.png',
    'reflective-gold-rowing-kit': CDN + 'kit-flatlay-reflective-gold-rowing-kit.png',
    'reflective-purple-cyclist-kit': CDN + 'kit-flatlay-reflective-purple-cyclist-kit.png',
    'reflective-purple-rowing-kit': CDN + 'kit-flatlay-reflective-purple-rowing-kit.png',
    'reflective-blue-cyclist-kit': CDN + 'kit-flatlay-reflective-blue-cyclist-kit.png',
    'polarized-rowing-kit': CDN + 'kit-flatlay-polarized-rowing-kit.png',
    'polarized-cyclist-kit': CDN + 'kit-flatlay-polarized-cyclist-kit.png'
  };
  /* per-kit prescription flat-lay; the bare insert frame is white-on-white and
     reads as an empty card, so it is only the fallback */
  var RXIMG = {
    'essential-cyclist-kit': CDN + 'kit-flatlay-essential-cyclist-kit-prescription.png',
    'performance-cyclist-kit': CDN + 'kit-flatlay-performance-cyclist-kit-prescription.png',
    'essential-rowing-kit': CDN + 'kit-flatlay-essential-rowing-kit-prescription.png',
    'performance-rowing-kit': CDN + 'kit-flatlay-performance-rowing-kit-prescription.png',
    'reflective-gold-cyclist-kit': CDN + 'kit-flatlay-reflective-gold-cyclist-kit-prescription.png',
    'reflective-gold-rowing-kit': CDN + 'kit-flatlay-reflective-gold-rowing-kit-prescription.png',
    'reflective-purple-cyclist-kit': CDN + 'kit-flatlay-reflective-purple-cyclist-kit-prescription.png',
    'reflective-purple-rowing-kit': CDN + 'kit-flatlay-reflective-purple-rowing-kit-prescription.png',
    'reflective-blue-cyclist-kit': CDN + 'kit-flatlay-reflective-blue-cyclist-kit-prescription.png',
    'polarized-rowing-kit': CDN + 'kit-flatlay-polarized-rowing-kit-prescription.png',
    'polarized-cyclist-kit': CDN + 'kit-flatlay-polarized-cyclist-kit-prescription.png'
  };
  var RXFALLBACK = CDN + 'prescription-insert-frame-803261.jpg';
  var KITS = [
    /* ---- Original kits (created 2026-09-02): glasses + matching lens with mirror + Large mirror (cyclist) or float retainer (rowing) + neckwear; no Rx twin ---- */
    { key: 'high-contrast-cyclist-kit-left', handle: 'high-contrast-cyclist-kit-left', lens: /^High Contrast Smoke$/, color: /Matte Black/i, mirror: /Left/i, gen: 'original',
      variant: 45250322858027, title: 'High Contrast Cyclist Kit', num: 129, was: 152,
      line: 'Adds a Yellow lens with mirror, Large mirror and neckwear.',
      thumbs: [IMG.yellowL, IMG.mirL, IMG.nwBW] },
    { key: 'high-contrast-cyclist-kit-right', handle: 'high-contrast-cyclist-kit-right', lens: /^High Contrast Smoke$/, color: /Matte Black/i, mirror: /Right/i, gen: 'original',
      variant: 45250324922411, title: 'High Contrast Cyclist Kit', num: 129, was: 152.0,
      line: 'Adds a Yellow lens with mirror, Large mirror and neckwear.',
      thumbs: [IMG.yellowR, IMG.mirR, IMG.nwBW] },
    { key: 'polarized-original-cyclist-kit-left', handle: 'polarized-original-cyclist-kit-left', lens: /^Polarized Smoke$/, color: /Matte Black/i, mirror: /Left/i, gen: 'original',
      variant: 45250325348395, title: 'Polarized Cyclist Kit', num: 189, was: 222.0,
      line: 'Adds a Clear lens with mirror, Large mirror and neckwear.',
      thumbs: [IMG.clearL, IMG.mirL, IMG.nwBW] },
    { key: 'polarized-original-cyclist-kit-right', handle: 'polarized-original-cyclist-kit-right', lens: /^Polarized Smoke$/, color: /Matte Black/i, mirror: /Right/i, gen: 'original',
      variant: 45250326659115, title: 'Polarized Cyclist Kit', num: 189, was: 222.0,
      line: 'Adds a Clear lens with mirror, Large mirror and neckwear.',
      thumbs: [IMG.clearR, IMG.mirR, IMG.nwBW] },
    { key: 'photochromic-cyclist-kit-left', handle: 'photochromic-cyclist-kit-left', lens: /^Photochromic Smoke 0–3$/, color: /Matte Black/i, mirror: /Left/i, gen: 'original',
      variant: 45250326986795, title: 'Photochromic Cyclist Kit', num: 199, was: 232.0,
      line: 'Adds a Yellow lens with mirror, Large mirror and neckwear.',
      thumbs: [IMG.yellowL, IMG.mirL, IMG.nwBW] },
    { key: 'photochromic-cyclist-kit-right', handle: 'photochromic-cyclist-kit-right', lens: /^Photochromic Smoke 0–3$/, color: /Matte Black/i, mirror: /Right/i, gen: 'original',
      variant: 45250327314475, title: 'Photochromic Cyclist Kit', num: 199, was: 232.0,
      line: 'Adds a Yellow lens with mirror, Large mirror and neckwear.',
      thumbs: [IMG.yellowR, IMG.mirR, IMG.nwBW] },
    { key: 'reflective-red-cyclist-kit-left', handle: 'reflective-red-cyclist-kit-left', lens: /^Reflective Red$/, color: /Matte Black/i, mirror: /Left/i, gen: 'original',
      variant: 45250327642155, title: 'Reflective Red Cyclist Kit', num: 149, was: 172.0,
      line: 'Adds a Yellow lens with mirror, Large mirror and neckwear.',
      thumbs: [IMG.yellowL, IMG.mirL, IMG.nwBW] },
    { key: 'reflective-red-cyclist-kit-right', handle: 'reflective-red-cyclist-kit-right', lens: /^Reflective Red$/, color: /Matte Black/i, mirror: /Right/i, gen: 'original',
      variant: 45250328068139, title: 'Reflective Red Cyclist Kit', num: 149, was: 172.0,
      line: 'Adds a Yellow lens with mirror, Large mirror and neckwear.',
      thumbs: [IMG.yellowR, IMG.mirR, IMG.nwBW] },
    { key: 'reflective-blue-original-cyclist-kit-left', handle: 'reflective-blue-original-cyclist-kit-left', lens: /^Reflective Blue$/, color: /Matte Black/i, mirror: /Left/i, gen: 'original',
      variant: 45250328428587, title: 'Reflective Blue Cyclist Kit', num: 149, was: 172.0,
      line: 'Adds a Clear lens with mirror, Large mirror and neckwear.',
      thumbs: [IMG.clearL, IMG.mirL, IMG.nwBW] },
    { key: 'reflective-blue-original-cyclist-kit-right', handle: 'reflective-blue-original-cyclist-kit-right', lens: /^Reflective Blue$/, color: /Matte Black/i, mirror: /Right/i, gen: 'original',
      variant: 45250329018411, title: 'Reflective Blue Cyclist Kit', num: 149, was: 172.0,
      line: 'Adds a Clear lens with mirror, Large mirror and neckwear.',
      thumbs: [IMG.clearR, IMG.mirR, IMG.nwBW] },
    { key: 'photochromic-0-2-cyclist-kit-left', handle: 'photochromic-0-2-cyclist-kit-left', lens: /^Photochromic Smoke 0–2$/, color: /Matte Black/i, mirror: /Left/i, gen: 'original',
      variant: 45250329378859, title: 'Photochromic 0-2 Cyclist Kit', num: 179, was: 202.0,
      line: 'Adds a Yellow lens with mirror, Large mirror and neckwear.',
      thumbs: [IMG.yellowL, IMG.mirL, IMG.nwBW] },
    { key: 'photochromic-0-2-cyclist-kit-right', handle: 'photochromic-0-2-cyclist-kit-right', lens: /^Photochromic Smoke 0–2$/, color: /Matte Black/i, mirror: /Right/i, gen: 'original',
      variant: 45250329837611, title: 'Photochromic 0-2 Cyclist Kit', num: 179, was: 202.0,
      line: 'Adds a Yellow lens with mirror, Large mirror and neckwear.',
      thumbs: [IMG.yellowR, IMG.mirR, IMG.nwBW] },
    { key: 'standard-clear-rowing-kit', handle: 'standard-clear-rowing-kit', lens: /^Standard Clear$/, color: /Matte Black/i, mirror: /Dual/i, gen: 'original',
      variant: 45250331148331, title: 'Standard Clear Rowing Kit', num: 189, was: 214.9,
      line: 'Adds a Polarized Smoke lens with mirror, float retainer and neckwear.',
      thumbs: [IMG.polD, IMG.flt, IMG.nwBW] },
    { key: 'reflective-blue-original-rowing-kit', handle: 'reflective-blue-original-rowing-kit', lens: /^Reflective Blue$/, color: /Matte Black/i, mirror: /Dual/i, gen: 'original',
      variant: 45250331508779, title: 'Reflective Blue Rowing Kit', num: 149, was: 174.9,
      line: 'Adds a Clear lens with mirror, float retainer and neckwear.',
      thumbs: [IMG.clearD, IMG.flt, IMG.nwBW] },
    { key: 'photochromic-0-2-rowing-kit', handle: 'photochromic-0-2-rowing-kit', lens: /^Photochromic Smoke 0–2$/, color: /Matte Black/i, mirror: /Dual/i, gen: 'original',
      variant: 45250331869227, title: 'Photochromic 0-2 Rowing Kit', num: 209, was: 234.9,
      line: 'Adds a Reflective Blue lens with mirror, float retainer and neckwear.',
      thumbs: [IMG.blueD, IMG.flt, IMG.nwBW] },
    { key: 'performance-cyclist', handle: 'performance-cyclist-kit', lens: /^Photochromic Smoke 0–3 Sharp$/, color: /Matte Black/i, mirror: /Left/i,
      variant: 44742206455851, alts: [50484893024299,50484893057067], title: 'Performance Cyclist Kit', num: 214, was: 252,
      rxVariant: 45117059334187, rxAlts: [50484970782763,50484970815531], rxNum: 219, rxWas: 257,
      line: 'Adds a mirror-free reflective lens, nosepad set and neckwear.',
      thumbs: [IMG.gold, IMG.nose, IMG.nwWB] },
    { key: 'performance-cyclist-r', handle: 'performance-cyclist-kit', lens: /^Photochromic Smoke 0–3 Sharp$/, color: /Matte Black/i, mirror: /Right/i,
      variant: 44841014951979, alts: [50484893089835,50484893122603], title: 'Performance Cyclist Kit', num: 214, was: 252,
      rxVariant: 45117059366955, rxAlts: [50484970848299,50484970881067], rxNum: 219, rxWas: 257,
      line: 'Adds a mirror-free reflective lens, nosepad set and neckwear.',
      thumbs: [IMG.gold, IMG.nose, IMG.nwWB] },
    { key: 'performance-rowing', handle: 'performance-rowing-kit', lens: /^Photochromic Smoke 0–3 Sharp$/, color: /Matte Black/i, mirror: /Dual/i,
      variant: 44846080688171, alts: [50484961771563,50484961804331], title: 'Performance Rowing Kit', num: 221, was: 259.90,
      rxVariant: 45117079093291, rxAlts: [50484980252715,50484980285483], rxNum: 226, rxWas: 264.90,
      line: 'Adds a mirror-free reflective lens, nosepads, neckwear and float retainer.',
      thumbs: [IMG.gold, IMG.nose, IMG.nwRB, IMG.flt] },
    { key: 'essential-cyclist', handle: 'essential-cyclist-kit', lens: /^High Contrast Smoke Sharp$/, color: /Matte Black/i, mirror: /Left/i,
      variant: 44742202753067, alts: [50484669710379,50484669743147], title: 'Essential Cyclist Kit', num: 149, was: 172,
      rxVariant: 45117046358059, rxAlts: [50484964294699,50484964327467], rxNum: 154, rxWas: 177,
      line: 'Adds a mirror-free reflective lens, nosepad set and neckwear.',
      thumbs: [IMG.blue, IMG.nose, IMG.nwBW] },
    { key: 'essential-cyclist-r', handle: 'essential-cyclist-kit', lens: /^High Contrast Smoke Sharp$/, color: /Matte Black/i, mirror: /Right/i,
      variant: 50484669775915, alts: [50484669808683,50484669841451], title: 'Essential Cyclist Kit', num: 149, was: 172,
      rxVariant: 50484964360235, rxAlts: [50484964393003,50484964425771], rxNum: 154, rxWas: 177,
      line: 'Adds a mirror-free reflective lens, nosepad set and neckwear.',
      thumbs: [IMG.blue, IMG.nose, IMG.nwBW] },
    { key: 'essential-rowing', handle: 'essential-rowing-kit', lens: /^High Contrast Smoke Sharp$/, color: /Matte Black/i, mirror: /Dual/i,
      variant: 44846069973035, alts: [50484954890283,50484954923051], title: 'Essential Rowing Kit', num: 157, was: 179.90,
      rxVariant: 45117069230123, rxAlts: [50484977303595,50484977336363], rxNum: 162, rxWas: 184.90,
      line: 'Adds a mirror-free reflective lens, nosepads, neckwear and float retainer.',
      thumbs: [IMG.blue, IMG.nose, IMG.nwBW, IMG.flt] },
    { key: 'polarized-rowing', handle: 'polarized-rowing-kit', lens: /^Polarized Smoke Sharp$/, color: /Matte Black/i, mirror: /Dual/i,
      variant: 45119099371563, title: 'Polarized Rowing Kit', num: 190, was: 223,
      rxVariant: 45119099633707, rxNum: 195, rxWas: 228,
      line: 'Adds a mirror-free Blue lens and an extra nosepad set.',
      rxLine: 'Adds a mirror-free Blue lens and the prescription insert frame instead of the extra nosepad.',
      thumbs: [IMG.blue, IMG.nose] },
    { key: 'polarized-cyclist', handle: 'polarized-cyclist-kit', lens: /^Polarized Smoke Sharp$/, color: /Matte Black/i, mirror: /Left/i,
      variant: 45136075980843, title: 'Polarized Cyclist Kit', num: 189, was: 222,
      rxVariant: 45136082337835, rxNum: 194, rxWas: 227,
      line: 'Adds a mirror-free High Contrast lens, nosepad set and neckwear.',
      thumbs: [IMG.hc, IMG.nose, IMG.nwBW] },
    { key: 'polarized-cyclist-r', handle: 'polarized-cyclist-kit', lens: /^Polarized Smoke Sharp$/, color: /Matte Black/i, mirror: /Right/i,
      variant: 45136076013611, title: 'Polarized Cyclist Kit', num: 189, was: 222,
      rxVariant: 45136082370603, rxNum: 194, rxWas: 227,
      line: 'Adds a mirror-free High Contrast lens, nosepad set and neckwear.',
      thumbs: [IMG.hc, IMG.nose, IMG.nwBW] },
    { key: 'refl-gold-cyclist', handle: 'reflective-gold-cyclist-kit', lens: /^Reflective Gold Sharp$/, color: /Matte Olive/i, mirror: /Left/i,
      variant: 45117439541291, title: 'Reflective Gold Cyclist Kit', num: 151, was: 177,
      rxVariant: 45117455761451, rxNum: 168, rxWas: 197,
      line: 'Adds a matching mirror-free Gold lens and black neckwear.',
      rxLine: 'Adds a matching mirror-free Gold lens, prescription insert frame and black neckwear.',
      thumbs: [IMG.gold, IMG.nwBW] },
    { key: 'refl-gold-cyclist-r', handle: 'reflective-gold-cyclist-kit', lens: /^Reflective Gold Sharp$/, color: /Matte Olive/i, mirror: /Right/i,
      variant: 45117439574059, title: 'Reflective Gold Cyclist Kit', num: 151, was: 177,
      rxVariant: 45117455794219, rxNum: 168, rxWas: 197,
      line: 'Adds a matching mirror-free Gold lens and black neckwear.',
      rxLine: 'Adds a matching mirror-free Gold lens, prescription insert frame and black neckwear.',
      thumbs: [IMG.gold, IMG.nwBW] },
    { key: 'refl-gold-rowing', handle: 'reflective-gold-rowing-kit', lens: /^Reflective Gold Sharp$/, color: /Matte Olive/i, mirror: /Dual/i,
      variant: 45117465755691, title: 'Reflective Gold Rowing Kit', num: 125, was: 145.90,
      rxVariant: 45117478895659, rxNum: 142, rxWas: 165.90,
      line: 'Adds the float retainer and black neckwear.',
      rxLine: 'Adds the float retainer, prescription insert frame and black neckwear.',
      thumbs: [IMG.flt, IMG.nwBW] },
    { key: 'refl-purple-cyclist', handle: 'reflective-purple-cyclist-kit', lens: /^Reflective Purple Sharp$/, color: /Crystal Violet/i, mirror: /Left/i,
      variant: 45117485776939, title: 'Reflective Purple Cyclist Kit', num: 151, was: 177,
      rxVariant: 45117499179051, rxNum: 168, rxWas: 197,
      line: 'Adds a matching mirror-free Purple lens and black neckwear.',
      rxLine: 'Adds a matching mirror-free Purple lens, prescription insert frame and black neckwear.',
      thumbs: [IMG.purple, IMG.nwBW] },
    { key: 'refl-purple-cyclist-r', handle: 'reflective-purple-cyclist-kit', lens: /^Reflective Purple Sharp$/, color: /Crystal Violet/i, mirror: /Right/i,
      variant: 45117485809707, title: 'Reflective Purple Cyclist Kit', num: 151, was: 177,
      rxVariant: 45117499211819, rxNum: 168, rxWas: 197,
      line: 'Adds a matching mirror-free Purple lens and black neckwear.',
      rxLine: 'Adds a matching mirror-free Purple lens, prescription insert frame and black neckwear.',
      thumbs: [IMG.purple, IMG.nwBW] },
    { key: 'refl-purple-rowing', handle: 'reflective-purple-rowing-kit', lens: /^Reflective Purple Sharp$/, color: /Crystal Violet/i, mirror: /Dual/i,
      variant: 45117512220715, title: 'Reflective Purple Rowing Kit', num: 125, was: 145.90,
      rxVariant: 45117528604715, rxNum: 142, rxWas: 165.90,
      line: 'Adds the float retainer and black neckwear.',
      rxLine: 'Adds the float retainer, prescription insert frame and black neckwear.',
      thumbs: [IMG.flt, IMG.nwBW] },
    { key: 'refl-blue-cyclist', handle: 'reflective-blue-cyclist-kit', lens: /^Reflective Blue Sharp$/, color: /Matte Black/i, mirror: /Left/i,
      variant: 45117548265515, title: 'Reflective Blue Cyclist Kit', num: 151, was: 177,
      rxVariant: 45117561667627, rxNum: 168, rxWas: 197,
      line: 'Adds a matching mirror-free Blue lens and black neckwear.',
      rxLine: 'Adds a matching mirror-free Blue lens, prescription insert frame and black neckwear.',
      thumbs: [IMG.blue, IMG.nwBW] },
    { key: 'refl-blue-cyclist-r', handle: 'reflective-blue-cyclist-kit', lens: /^Reflective Blue Sharp$/, color: /Matte Black/i, mirror: /Right/i,
      variant: 45117548298283, title: 'Reflective Blue Cyclist Kit', num: 151, was: 177,
      rxVariant: 45117561700395, rxNum: 168, rxWas: 197,
      line: 'Adds a matching mirror-free Blue lens and black neckwear.',
      rxLine: 'Adds a matching mirror-free Blue lens, prescription insert frame and black neckwear.',
      thumbs: [IMG.blue, IMG.nwBW] },
    /* S · 140 kits — same structure as the M · 145 originals, with the same Large
       mirror as the size-up (Medium is what every single-mirror model already ships). Added 2026-09-04. */
    { key: 'hc-cyclist-s140-left', handle: 'high-contrast-cyclist-kit-s-left-mirror', lens: /^High Contrast Smoke$/, color: /Matte Black/i, mirror: /Left/i, size: /140/, gen: 'original',
      variant: 45264517595179, title: 'High Contrast Cyclist Kit S', num: 129, was: 152,
      line: 'Adds a Yellow lens with mirror, Large mirror and neckwear.',
      thumbs: [IMG.yellowL, IMG.mirL, IMG.nwBW] },
    { key: 'hc-cyclist-s140-right', handle: 'high-contrast-cyclist-kit-s-right-mirror', lens: /^High Contrast Smoke$/, color: /Matte Black/i, mirror: /Right/i, size: /140/, gen: 'original',
      variant: 45264519233579, title: 'High Contrast Cyclist Kit S', num: 129, was: 152,
      line: 'Adds a Yellow lens with mirror, Large mirror and neckwear.',
      thumbs: [IMG.yellowR, IMG.mirR, IMG.nwBW] },
    { key: 'photo02-cyclist-s140-white-left', handle: 'photochromic-0-2-cyclist-kit-s-white-left-mirror', lens: /^Photochromic Smoke 0–2$/, color: /^White$/i, mirror: /Left/i, size: /140/, gen: 'original',
      variant: 45264520380459, title: 'Photochromic 0-2 Cyclist Kit S', num: 179, was: 202,
      line: 'Adds a Yellow lens with mirror, Large mirror and neckwear.',
      thumbs: [IMG.yellowL, IMG.mirL, IMG.nwBW] },
    { key: 'rose-cyclist-s140-left', handle: 'reflective-rose-cyclist-kit-s-left-mirror', lens: /^Reflective Ros/, color: /Crystal Pink/i, mirror: /Left/i, size: /140/, gen: 'original',
      variant: 45264521658411, title: 'Reflective Rosè Cyclist Kit S', num: 149, was: 172,
      line: 'Adds a Clear lens with mirror, Large mirror and neckwear.',
      thumbs: [IMG.clearL, IMG.mirL, IMG.nwBW] },
    { key: 'blue-cyclist-s140-left', handle: 'reflective-blue-cyclist-kit-s-left-mirror', lens: /^Reflective Blue$/, color: /Matte Black/i, mirror: /Left/i, size: /140/, gen: 'original',
      variant: 45264522510379, title: 'Reflective Blue Cyclist Kit S', num: 149, was: 172,
      line: 'Adds a Clear lens with mirror, Large mirror and neckwear.',
      thumbs: [IMG.clearL, IMG.mirL, IMG.nwBW] },
    { key: 'photo02-rowing-s140', handle: 'photochromic-0-2-rowing-kit-s', lens: /^Photochromic Smoke 0–2$/, color: /Matte Black/i, mirror: /Dual/i, size: /140/, gen: 'original',
      variant: 45269890105387, title: 'Photochromic 0-2 Rowing Kit S', num: 239, was: 274.9,
      line: 'Adds a Polarized Smoke lens with mirror, float retainer and neckwear.',
      thumbs: [IMG.polD, IMG.flt, IMG.nwBW] },
    /* The Clip. Its configurator has no frame colour, so its colour rule matches anything and
       the lens type carries Sharp/Original. Sharp keeps its own optimised mirror,
       so those kits add only the neckwear; the Originals add the replacement
       mirror too. The S · 140 kits ship the white neckwear instead, which sets
       the small kits apart on the shelf. 2026-09-17: the Clear kits used to ship
       the Warm Orange neckwear; it was moved to a hidden gift-only product and
       those five kits now ship Black & White like the Polarized ones.
       Every Clip kit saves exactly 10. Added 2026-09-04. */
    { key: 'clip-pol-left', handle: 'clip-polarized-kit-left-mirror', product: 'clip', lens: /^Polarized Smoke$/, color: /.*/, mirror: /Left/i, size: /145/, gen: 'original',
      variant: 45270122659883, title: 'Clip Polarized Kit', num: 93, was: 103,
      line: 'Adds a spare mirror and neckwear.',
      thumbs: [IMG.mirLc, IMG.nwBW] },
    { key: 'clip-clear-left', handle: 'clip-clear-kit-left-mirror', product: 'clip', lens: /^Clear Polycarbonate$/, color: /.*/, mirror: /Left/i, size: /145/, gen: 'original',
      variant: 45270130524203, title: 'Clip Clear Kit', num: 83, was: 93,
      line: 'Adds a spare mirror and neckwear.',
      thumbs: [IMG.mirLc, IMG.nwBW] },
    { key: 'clip-pol-left-s', handle: 'clip-polarized-kit-s-left-mirror', product: 'clip', lens: /^Polarized Smoke$/, color: /.*/, mirror: /Left/i, size: /140/, gen: 'original',
      variant: 45270133473323, title: 'Clip Polarized Kit S', num: 93, was: 103,
      line: 'Adds a spare mirror and neckwear.',
      thumbs: [IMG.mirLc, IMG.nwWB] },
    { key: 'clip-clear-left-s', handle: 'clip-clear-kit-s-left-mirror', product: 'clip', lens: /^Clear Polycarbonate$/, color: /.*/, mirror: /Left/i, size: /140/, gen: 'original',
      variant: 45270146056235, title: 'Clip Clear Kit S', num: 83, was: 93,
      line: 'Adds a spare mirror and neckwear.',
      thumbs: [IMG.mirLc, IMG.nwWB] },
    { key: 'clip-pol-right', handle: 'clip-polarized-kit-right-mirror', product: 'clip', lens: /^Polarized Smoke$/, color: /.*/, mirror: /Right/i, size: /145/, gen: 'original',
      variant: 45270152544299, title: 'Clip Polarized Kit', num: 93, was: 103,
      line: 'Adds a spare mirror and neckwear.',
      thumbs: [IMG.mirRc, IMG.nwBW] },
    { key: 'clip-clear-right', handle: 'clip-clear-kit-right-mirror', product: 'clip', lens: /^Clear Polycarbonate$/, color: /.*/, mirror: /Right/i, size: /145/, gen: 'original',
      variant: 45270158311467, title: 'Clip Clear Kit', num: 83, was: 93,
      line: 'Adds a spare mirror and neckwear.',
      thumbs: [IMG.mirRc, IMG.nwBW] },
    { key: 'clip-pol-sharp-dual', handle: 'clip-polarized-sharp-kit-dual-mirror', product: 'clip', lens: /^Polarized Smoke Sharp$/, color: /.*/, mirror: /Dual/i, size: /145/,
      variant: 45270161883179, title: 'Clip Polarized Sharp Kit', num: 88, was: 98,
      line: 'Adds neckwear.',
      thumbs: [IMG.nwBW] },
    { key: 'clip-clear-sharp-dual', handle: 'clip-clear-sharp-kit-dual-mirror', product: 'clip', lens: /^Clear Polycarbonate Sharp$/, color: /.*/, mirror: /Dual/i, size: /145/,
      variant: 45270174269483, title: 'Clip Clear Sharp Kit', num: 78, was: 88,
      line: 'Adds neckwear.',
      thumbs: [IMG.nwBW] },
    { key: 'clip-pol-sharp-left', handle: 'clip-polarized-sharp-kit-left-mirror', product: 'clip', lens: /^Polarized Smoke Sharp$/, color: /.*/, mirror: /Left/i, size: /145/,
      variant: 45270259040299, title: 'Clip Polarized Sharp Kit', num: 88, was: 98,
      line: 'Adds neckwear.',
      thumbs: [IMG.nwBW] },
    { key: 'clip-clear-sharp-left', handle: 'clip-clear-sharp-kit-left-mirror', product: 'clip', lens: /^Clear Polycarbonate Sharp$/, color: /.*/, mirror: /Left/i, size: /145/,
      variant: 45270268870699, title: 'Clip Clear Sharp Kit', num: 78, was: 88,
      line: 'Adds neckwear.',
      thumbs: [IMG.nwBW] },
    { key: 'clip-pol-right-s', handle: 'clip-polarized-kit-s-right-mirror', product: 'clip', lens: /^Polarized Smoke$/, color: /.*/, mirror: /Right/i, size: /140/, gen: 'original',
      variant: 45270292398123, title: 'Clip Polarized Kit S', num: 93, was: 103,
      line: 'Adds a spare mirror and neckwear.',
      thumbs: [IMG.mirRc, IMG.nwWB] },
    { key: 'clip-clear-right-s', handle: 'clip-clear-kit-s-right-mirror', product: 'clip', lens: /^Clear Polycarbonate$/, color: /.*/, mirror: /Right/i, size: /140/, gen: 'original',
      variant: 45270303113259, title: 'Clip Clear Kit S', num: 83, was: 93,
      line: 'Adds a spare mirror and neckwear.',
      thumbs: [IMG.mirRc, IMG.nwWB] },
    { key: 'clip-pol-sharp-dual-s', handle: 'clip-polarized-sharp-kit-s-dual-mirror', product: 'clip', lens: /^Polarized Smoke Sharp$/, color: /.*/, mirror: /Dual/i, size: /140/,
      variant: 45270318546987, title: 'Clip Polarized Sharp Kit S', num: 88, was: 98,
      line: 'Adds neckwear.',
      thumbs: [IMG.nwWB] },
    { key: 'clip-pol-sharp-left-s', handle: 'clip-polarized-sharp-kit-s-left-mirror', product: 'clip', lens: /^Polarized\sSmoke\sSharp$/, color: /.*/, mirror: /Left/i, size: /140/,
      variant: 45270329098283, title: 'Clip Polarized Sharp Kit S', num: 88, was: 98,
      line: 'Adds neckwear.',
      thumbs: [IMG.nwWB] },
    { key: 'clip-pol-sharp-right-s', handle: 'clip-polarized-sharp-kit-s-right-mirror', product: 'clip', lens: /^Polarized\sSmoke\sSharp$/, color: /.*/, mirror: /Right/i, size: /140/,
      variant: 45270329196587, title: 'Clip Polarized Sharp Kit S', num: 88, was: 98,
      line: 'Adds neckwear.',
      thumbs: [IMG.nwWB] },
    { key: 'clip-clear-sharp-dual-s', handle: 'clip-clear-sharp-kit-s-dual-mirror', product: 'clip', lens: /^Clear\sPolycarbonate\sSharp$/, color: /.*/, mirror: /Dual/i, size: /140/,
      variant: 45270329262123, title: 'Clip Clear Sharp Kit S', num: 78, was: 88,
      line: 'Adds neckwear.',
      thumbs: [IMG.nwWB] },
    { key: 'clip-clear-sharp-left-s', handle: 'clip-clear-sharp-kit-s-left-mirror', product: 'clip', lens: /^Clear\sPolycarbonate\sSharp$/, color: /.*/, mirror: /Left/i, size: /140/,
      variant: 45270329294891, title: 'Clip Clear Sharp Kit S', num: 78, was: 88,
      line: 'Adds neckwear.',
      thumbs: [IMG.nwWB] },
    { key: 'clip-clear-sharp-right-s', handle: 'clip-clear-sharp-kit-s-right-mirror', product: 'clip', lens: /^Clear\sPolycarbonate\sSharp$/, color: /.*/, mirror: /Right/i, size: /140/,
      variant: 45270329360427, title: 'Clip Clear Sharp Kit S', num: 78, was: 88,
      line: 'Adds neckwear.',
      thumbs: [IMG.nwWB] },
    { key: 'clip-pol-sharp-right', handle: 'clip-polarized-sharp-kit-right-mirror', product: 'clip', lens: /^Polarized\sSmoke\sSharp$/, color: /.*/, mirror: /Right/i, size: /145/,
      variant: 45270400106539, title: 'Clip Polarized Sharp Kit', num: 88, was: 98,
      line: 'Adds neckwear.',
      thumbs: [IMG.nwBW] },
    { key: 'clip-clear-sharp-right', handle: 'clip-clear-sharp-kit-right-mirror', product: 'clip', lens: /^Clear\sPolycarbonate\sSharp$/, color: /.*/, mirror: /Right/i, size: /145/,
      variant: 45270400303147, title: 'Clip Clear Sharp Kit', num: 78, was: 88,
      line: 'Adds neckwear.',
      thumbs: [IMG.nwBW] }
  ];

  function abGroup() {
    try {
      /* Elevate integration: a variant script may set window.__triKitABForce = 'A'|'B'
         (or write localStorage.triKitMatchAB directly). The forced value always wins
         and is persisted, so Elevate owns the split when a test is configured there;
         without it we self-assign 50/50. */
      var forced = window.__triKitABForce;
      if (forced === 'A' || forced === 'B') {
        localStorage.setItem('triKitMatchAB', forced);
        return forced;
      }
      var g = localStorage.getItem('triKitMatchAB');
      if (g !== 'A' && g !== 'B') {
        g = Math.random() < 0.5 ? 'A' : 'B';
        localStorage.setItem('triKitMatchAB', g);
      }
      return g;
    } catch (e) { return 'A'; }
  }
  function track(ev, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      var p = { event: ev, ab_group: GROUP };
      if (data) for (var k in data) p[k] = data[k];
      window.dataLayer.push(p);
    } catch (e) {}
  }
  /* Elevate experiment "Din pakke on The View PDP" (2dacb1d0), earlier "Complete Your Kit module" (1dd8e5a3, done):
     the split is OWNED by Elevate when the test is running — we read the
     assignment Elevate stamps into cart attributes (_eabList: {testId: variationId}).
     Control 51495 -> A, Variation 1 51496 -> B. Fallbacks, in order:
     window.__triKitABForce, Elevate assignment, sticky self 50/50. */
  var EAB_TEST = '2dacb1d0-917c-412b-a262-1116d13b6fe8';   /* Din pakke on The View PDP (2026-09-02) */
  var EAB_MAP = { '52300': 'A', '52301': 'B', '51495': 'A', '51496': 'B' };   /* new test + the finished one, harmless */
  var GROUP = null;

  var PREVIEW = false;
  var ALWAYS = false;   /* page shows the module outside the A/B test */   /* ?kitab=A|B preview: render the group without tracking or stamping */
  function initGroup(cb) {
    try {
      var qp = new URLSearchParams(location.search).get('kitab');
      if (qp === 'A' || qp === 'B') { PREVIEW = true; cb(qp); return; }
    } catch (e) {}
    /* Pages that opt in with window.__triKitAlways (The Clip) always get the
       module: the Elevate test only targets The View, so waiting for an
       assignment there would leave the module hidden for ever. Those visitors
       are not part of the test, so they must not stamp _kit_ab on the cart. */
    try { if (window.__triKitAlways) { ALWAYS = true; cb('B'); return; } } catch (e) {}
    try {
      var forced = window.__triKitABForce;
      if (forced === 'A' || forced === 'B') { try { localStorage.setItem('triKitMatchAB', forced); } catch (e) {} cb(forced); return; }
    } catch (e) {}
    var tries = 0;
    function poll() {
      tries++;
      /* Elevate's variation JS may run after this script initialised: honour a
         late window.__triKitABForce first, so a new test works without ids here */
      try {
        var late = window.__triKitABForce;
        if (late === 'A' || late === 'B') { try { localStorage.setItem('triKitMatchAB', late); } catch (e0) {} cb(late); return; }
      } catch (e1) {}
      fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) {
        var g = null;
        try {
          var list = JSON.parse((c.attributes || {})._eabList || '{}');
          var vid = String(list[EAB_TEST] || '');
          g = EAB_MAP[vid] || null;
        } catch (e) {}
        if (g) { try { localStorage.setItem('triKitMatchAB', g); } catch (e2) {} cb(g); }
        else if (tries < 12) { setTimeout(poll, 700); }
        /* No Elevate assignment (e.g. locale-prefixed URL, or test not running):
           do NOT self-assign — the visitor simply gets the control experience, so
           what visitors see always matches what Elevate measures. */
      }).catch(function () {
        if (tries < 12) setTimeout(poll, 700);
      });
    }
    poll();
  }
  function startModule(g) {
    GROUP = g;
    if (!PREVIEW) track('tri_kit_match_ab');
  /* Stamp the AB group on the cart so every order carries it to Admin as a
     note attribute (_kit_ab) — visible under "Additional details" on the
     order, hidden from customer-facing surfaces by the underscore prefix.
     Runs for BOTH groups; once per browser session (idempotent anyway). */
  try {
    if (!PREVIEW && !ALWAYS && sessionStorage.getItem('triKitABAttr') !== GROUP) {
      fetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { '_kit_ab': GROUP } })
      }).then(function (r) {
        if (r.ok) try { sessionStorage.setItem('triKitABAttr', GROUP); } catch (e) {}
      }).catch(function () {});
    }
  } catch (e) {}
    if (GROUP !== 'B') return;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', hook);
    } else {
      hook();
    }
  }

  /* Styles mirror the theme's own .nosepad-option (read as computed styles on
     trieye.com 2026-09-01): #fafafa fill, 1px #dcd8d2 line, 8px radius, no
     shadow; selected = #111 border + #f2efe9 fill. Barlow inherits from body. */
  /* Styles mirror the theme's own .nosepad-option tokens: #fafafa fill, 1px #dcd8d2
     line, 8px radius, no shadow, Barlow inherits. One list, hairline rows. */
  /* Variant A. Tokens from the theme's own option cards: #fafafa fill, #dcd8d2 line,
     8px radius, no shadow, Barlow inherits. */
  var CSS =
    '#tri-kit-complete{margin:24px 0 16px;padding-top:16px;border-top:2px solid #1a1a1a}#tri-kit-complete *{white-space:normal;box-sizing:border-box}' +
    '#tri-kit-complete .tkc-h{display:flex;justify-content:space-between;align-items:baseline;margin:0 0 8px}' +
    '#tri-kit-complete .tkc-h b{font-weight:600;font-size:17px;line-height:1.2;color:#222}#tri-kit-complete .tkc-h small{font-size:12px;color:#8a857e}' +
    '#tri-kit-complete .tkc-list{border:1px solid #dcd8d2;border-radius:8px;background:#fff;overflow:hidden}' +
    '#tri-kit-complete .tkc-r{display:grid;grid-template-columns:40px 1fr auto;gap:10px;align-items:center;padding:10px 12px;border-top:1px solid #ececec;background:#fff;text-align:left;width:100%;position:relative}' +
    '#tri-kit-complete .tkc-r:first-child{border-top:0}' +
    '#tri-kit-complete .tkc-r.enter{animation:tkcEnter .28s cubic-bezier(.16,1,.3,1) both}@keyframes tkcEnter{from{opacity:0;transform:translateY(-6px)}to{opacity:1;transform:none}}' +
    '#tri-kit-complete .tkc-th{width:40px;height:40px;border-radius:5px;border:1px solid #ececec;background:#fff;overflow:hidden}' +
    '#tri-kit-complete .tkc-th img{width:100%;height:100%;object-fit:cover;display:block}' +
    '#tri-kit-complete .tkc-t{min-width:0}#tri-kit-complete .tkc-t b{display:block;font-weight:600;font-size:14px;line-height:1.25}' +
    '#tri-kit-complete .tkc-t span{display:block;color:#5f5a53;font-size:12px;margin-top:1px}' +
    '#tri-kit-complete .tkc-act{display:flex;gap:10px;margin-top:2px}' +
    '#tri-kit-complete .tkc-act button{border:0;background:none;padding:0;font-size:12px;font-family:inherit;color:#5f5a53;text-decoration:underline;text-underline-offset:3px;text-decoration-color:#dcd8d2;cursor:pointer}' +
    '#tri-kit-complete .tkc-act button:hover{color:#222;text-decoration-color:#222}' +
    '#tri-kit-complete .tkc-pr{text-align:right;font-variant-numeric:tabular-nums;white-space:nowrap;font-size:14px}' +
    '#tri-kit-complete .tkc-pr b{font-weight:600;display:block}#tri-kit-complete .tkc-pr s{color:#8a857e;font-size:12px;display:block}' +
    /* kit switch box */
    '#tri-kit-complete .tkc-up{display:grid;grid-template-columns:30px 40px 1fr auto;gap:10px;align-items:center;margin-top:10px;padding:10px 12px;border:1px dashed #dcd8d2;border-radius:8px;background:#fafafa;cursor:pointer;width:100%;text-align:left;font-family:inherit;color:#222;position:relative}' +
    '#tri-kit-complete .tkc-up.is-on{border-style:solid;border-color:#1a1a1a;background:#f2efe9}' +
    '#tri-kit-complete .tkc-up:focus-visible{outline:2px solid #e97316;outline-offset:2px}' +
    '#tri-kit-complete .tkc-sw{width:30px;height:18px;border-radius:999px;background:#dcd8d2;position:relative;flex:none;display:block;transition:background .15s;cursor:pointer}' +
    '#tri-kit-complete .tkc-sw:before{content:"";position:absolute;inset:-8px}' +
    '#tri-kit-complete .tkc-sw:after{content:"";position:absolute;top:2px;left:2px;width:14px;height:14px;border-radius:50%;background:#fff;transition:left .15s}' +
    '#tri-kit-complete .is-on .tkc-sw{background:#1a1a1a}#tri-kit-complete .is-on .tkc-sw:after{left:14px}' +
    '#tri-kit-complete .tkc-up .tkc-pr i{display:block;font-style:normal;color:#107a3d;font-size:11px;font-weight:700}' +
    '#tri-kit-complete .tkc-kit{grid-column:1/-1;display:none;margin-top:6px;padding-top:10px;border-top:1px solid #dcd8d2}#tri-kit-complete .is-on .tkc-kit{display:block}' +
    '#tri-kit-complete .tkc-kr{display:grid;grid-template-columns:40px 1fr;gap:10px;align-items:center;padding:5px 0}' +
    '#tri-kit-complete .tkc-kr span{width:40px;height:40px;border-radius:5px;border:1px solid #ececec;background:#fff;overflow:hidden;display:block}' +
    '#tri-kit-complete .tkc-kr img{width:100%;height:100%;object-fit:cover;display:block}' +
    '#tri-kit-complete .tkc-kr b{display:block;font-size:13px;font-weight:600;line-height:1.2}#tri-kit-complete .tkc-kr i{display:block;font-style:normal;color:#5f5a53;font-size:12px}' +
    '#tri-kit-complete .tkc-sep{display:flex;justify-content:space-between;font-size:12.5px;color:#5f5a53;padding:8px 0 2px;border-top:1px solid #ececec;margin-top:4px}#tri-kit-complete .tkc-sep b{color:#222}' +
    '#tri-kit-complete .tkc-strip{display:grid;grid-template-columns:repeat(auto-fit,minmax(56px,1fr));gap:8px;margin-bottom:8px}' +
    '#tri-kit-complete .tkc-item span{display:block;aspect-ratio:1;border-radius:6px;overflow:hidden;background:#fff;border:1px solid #ececec;margin-bottom:4px}' +
    '#tri-kit-complete .tkc-item img{width:100%;height:100%;object-fit:cover;display:block}' +
    '#tri-kit-complete .tkc-item em{font-style:normal;font-size:10.5px;color:#5f5a53;line-height:1.25;display:block;text-align:center}#tri-kit-complete .tkc-item em i{display:block;font-style:normal;color:#8a857e;font-size:10px}' +
    '#tri-kit-complete .tkc-why{display:block;font-size:12px;color:#5f5a53;margin:0 0 8px}' +
    '#tri-kit-complete .tkc-rx{display:flex;align-items:center;gap:9px;padding:9px 11px;background:#fff;border:1px solid #ececec;border-radius:6px;font-size:12.5px;color:#222;cursor:pointer}' +
    '#tri-kit-complete .tkc-rx input{width:15px;height:15px;margin:0;accent-color:#111;flex:none}#tri-kit-complete .tkc-rx small{display:block;font-size:11px;color:#8a857e;margin-top:2px}#tri-kit-complete .tkc-rx b{margin-left:auto;font-weight:600;white-space:nowrap}' +
    /* add buttons */
    '#tri-kit-complete .tkc-add{display:flex;gap:8px;margin-top:10px}' +
    '#tri-kit-complete .tkc-add button{flex:1;display:flex;align-items:center;justify-content:space-between;gap:8px;border:1px solid #dcd8d2;background:#fff;border-radius:8px;padding:9px 12px;font-family:inherit;color:#222;cursor:pointer;text-align:left;min-width:0}' +
    '#tri-kit-complete .tkc-add button:hover{border-color:#1a1a1a}#tri-kit-complete .tkc-add button span{min-width:0}#tri-kit-complete .tkc-add button b{display:block;font-size:13px;font-weight:600;line-height:1.2}' +
    '#tri-kit-complete .tkc-add button i{display:block;font-style:normal;color:#5f5a53;font-weight:400;font-size:11.5px;line-height:1.3;margin-top:1px}#tri-kit-complete .tkc-add button u{text-decoration:none;color:#888;font-size:16px;flex:none}' +
    '@media (max-width:560px){#tri-kit-complete .tkc-add{flex-direction:column}}' +
    '#tri-kit-complete .tkc-add button:focus-visible{outline:2px solid #e97316;outline-offset:2px}' +
    /* total band */
    '#tri-kit-complete .tkc-tot{display:flex;justify-content:space-between;align-items:baseline;margin-top:12px;padding:12px 14px;background:#1a1a1a;color:#fff;border-radius:8px}' +
    '#tri-kit-complete .tkc-tot b{font-size:16px;font-variant-numeric:tabular-nums}#tri-kit-complete .tkc-tot .sv{color:#9be0b3;font-weight:600;font-size:12.5px;margin-left:8px}' +
    '#tri-kit-complete .bump{animation:tkcBump .3s ease-out}@keyframes tkcBump{30%{transform:scale(1.06)}}' +
    /* chooser */
    '#tri-kit-complete .tkc-ch{margin-top:12px;border:1px solid #dcd8d2;border-radius:8px;background:#fff;padding:12px 13px;animation:tkcEnter .25s cubic-bezier(.16,1,.3,1) both}' +
    '#tri-kit-complete .tkc-ch h4{margin:0 0 4px;font:600 13px inherit;font-family:inherit;color:#222}' +
    '#tri-kit-complete .tkc-sz{margin:0 0 10px;font-size:12px;color:#5f5a53}#tri-kit-complete .tkc-sz b{color:#222}' +
    '#tri-kit-complete .tkc-opts{display:grid;grid-template-columns:repeat(3,1fr);gap:8px}' +
    '#tri-kit-complete .tkc-o{position:relative;border:1px solid #dcd8d2;border-radius:8px;background:#fafafa;padding:7px 6px 8px;cursor:pointer;text-align:center;font-family:inherit;color:#222}' +
    '#tri-kit-complete .tkc-o.sel{border-color:#111;background:#f2efe9}' +
    '#tri-kit-complete .tkc-o div{aspect-ratio:1.25;border-radius:5px;overflow:hidden;background:#fff;border:1px solid #ececec;margin-bottom:6px}' +
    '#tri-kit-complete .tkc-o img{width:100%;height:100%;object-fit:cover;display:block}' +
    '#tri-kit-complete .tkc-o em{position:absolute;top:5px;left:5px;font-style:normal;font-size:9px;font-weight:700;letter-spacing:.4px;text-transform:uppercase;border-radius:4px;padding:2px 5px;background:#fff;border:1px solid #dcd8d2;color:#5f5a53}' +
    '#tri-kit-complete .tkc-o em.sharp{background:#111;color:#fff;border-color:#111}' +
    '#tri-kit-complete .tkc-o b{display:block;font-size:12px;line-height:1.2}#tri-kit-complete .tkc-o span{display:block;font-size:11px;color:#5f5a53;line-height:1.3}' +
    '#tri-kit-complete .tkc-o .pp{margin-top:3px;font-weight:600;color:#222;font-size:12px}#tri-kit-complete .tkc-o .pp s{color:#888;font-weight:400;margin-right:4px}' +
    '#tri-kit-complete .tkc-mir{margin-top:10px;min-height:56px;padding:8px 12px;border:1px solid #dcd8d2;border-radius:8px;background:#fafafa;display:flex;align-items:center;justify-content:space-between;gap:10px;flex-wrap:wrap}' +
    '#tri-kit-complete .tkc-note{margin:8px 0 0;font-size:12px;color:#9a5b00}' +
    '#tri-kit-complete .tkc-mir .t{font-size:12.5px;font-weight:600}' +
    '#tri-kit-complete .tkc-ms{display:flex;gap:6px;text-decoration:none}' +
    '#tri-kit-complete .tkc-mir .tkc-mt{font-size:12.5px;color:#5f5a53}' +
    '#tri-kit-complete .tkc-ms button{text-decoration:none;border:1px solid #dcd8d2;background:#fff;border-radius:999px;padding:6px 12px;font:600 12px inherit;font-family:inherit;color:#222;cursor:pointer}' +
    '#tri-kit-complete .tkc-ms button i{text-decoration:none;font-style:normal;font-weight:400;color:#5f5a53;margin-left:4px}' +
    '#tri-kit-complete .tkc-ms button.on{border-color:#111;background:#f2efe9}' +
    '#tri-kit-complete .tkc-all{display:block;width:100%;margin:10px 0 2px;border:0;background:none;padding:6px 0;font:600 13px inherit;font-family:inherit;color:#222;text-decoration:underline;text-underline-offset:3px;text-decoration-color:#dcd8d2;cursor:pointer;text-align:left}' +
    '#tri-kit-complete .tkc-all:hover{text-decoration-color:#222}' +
    '#tri-kit-complete .tkc-f{display:flex;justify-content:flex-end;gap:10px;margin-top:10px}' +
    '#tri-kit-complete .tkc-f button{font:600 13px inherit;font-family:inherit;border-radius:8px;padding:9px 14px;cursor:pointer;border:1px solid #dcd8d2;background:#fff;color:#222}' +
    '#tri-kit-complete .tkc-f button.pri{background:#1a1a1a;color:#fff;border-color:#1a1a1a}' +
    '#tri-kit-toast{position:fixed;left:50%;bottom:22px;transform:translateX(-50%) translateY(20px);background:#1a1a1a;color:#fff;padding:10px 16px;border-radius:999px;font:13px Barlow,inherit;opacity:0;pointer-events:none;transition:.25s;z-index:99998;display:flex;gap:8px;align-items:center}' +
    '#tri-kit-toast.show{opacity:1;transform:translateX(-50%)}' +
    '@media (max-width:560px){#tri-kit-complete .tkc-opts{grid-template-columns:repeat(3,1fr);gap:6px}#tri-kit-complete .tkc-strip{grid-template-columns:repeat(4,1fr)}}' +
    '@media (prefers-reduced-motion:reduce){#tri-kit-complete .tkc-r.enter,#tri-kit-complete .tkc-ch,#tri-kit-complete .bump{animation:none}#tri-kit-complete .is-on .tkc-mk svg,#tri-kit-complete .fixed .tkc-mk svg{stroke-dashoffset:0;animation:none}#tri-kit-toast{transition:none}}' +
    /* hide the theme's two category buttons, its heading and its collapsed "Your build" bar: the list replaces all three */
    'html.tkc-no-lens-disc .lens-picker__genhead-off,html.tkc-no-lens-disc [data-addon-lens-promo]{display:none !important}' +
    '.tkc-hide-addons .addon-categories,.tkc-hide-addons #tkc-miy-title,.tkc-hide-addons .config-accordion{display:none !important}';

  function ensureCss() {
    if (document.getElementById('tri-kit-complete-css')) return;
    var s = document.createElement('style');
    s.id = 'tri-kit-complete-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }
  function money(cents) {
    try { if (typeof formatMoneyDisplay === 'function') return formatMoneyDisplay(cents); } catch (e) {}
    var n = cents / 100;
    return '$' + (n % 1 ? n.toFixed(2) : n);
  }
  /* Copy: the theme's own strings are Liquid-only; this asset ships EN with a
     NO map keyed on the locale path prefix (same approach as the Clip note). */
  /* Copy lives here in six languages. English is the base; each language only
     overrides the keys it translates, so a key missed in one locale falls back
     to English instead of rendering "undefined". Product option values (lens
     names, Left/Right/Dual, Medium/Large) stay in English in every locale, the
     way the configurator itself shows them. */
  var L = (function () {
    var loc = '', path = '';
    try { loc = String((window.Shopify && window.Shopify.locale) || document.documentElement.lang || ''); } catch (e) {}
    try { path = location.pathname; } catch (e) {}
    function is(re, seg) { return re.test(loc) || new RegExp('^/(' + seg + ')(-[a-z]{2})?(/|$)', 'i').test(path); }
    var lang = is(/^(no|nb|nn)/i, 'no|nb|nn') ? 'no'
             : is(/^de/i, 'de') ? 'de'
             : is(/^fr/i, 'fr') ? 'fr'
             : is(/^it/i, 'it') ? 'it'
             : is(/^es/i, 'es') ? 'es' : 'en';
    var en = {
      head: 'Your package', headSub: 'everything that goes in the cart', parts: 'items', part: 'item',
      glasses: 'The View', sharp: 'The View Sharp', clip: 'The Clip', clipSharp: 'The Clip Sharp',
      upgrade: 'Upgrade to ', save: 'Save', sep: 'Bought separately', plus: '+ ',
      why: 'Mirror on the road. Mirror-free in the car and every day.',
      rx: 'Wear prescription? Swap the nosepad set for the insert frame.', rxAdd: 'Wear prescription? Add the insert frame.',
      rxHow: 'The frame sits behind the lens. Your optician fits the prescription.',
      lensT: 'Spare lens', lensD: 'With or without mirror', from: 'from ', pctWith: ' with the glasses',
      accT: 'Accessories', accD: 'Larger mirror, nosepads, neckwear', accDSharp: 'Nosepads, neckwear, Rx insert', lensBtnD: 'With or without mirror',
      total: 'Total', youSave: 'You save', edit: 'Change', remove: 'Remove',
      lensRow: 'Spare lens', mirrorRow: 'Larger mirror', nosepadRow: 'Nosepad', insertRow: 'Rx insert frame', accRow: 'Accessory',
      mirName: function (size, side) { return size + ' mirror, ' + side; }, fitBoth: 'Fits your glasses and the spare lens', fitGlasses: 'Fits your glasses', fitSpare: 'Fits the spare lens',
      chooseH: 'Spare lenses that fit ', sizeLine1: 'Shown in your size, ', sizeLine2: '. Sharp and Original both fit the frame.',
      leftM: 'Left mirror', rightM: 'Right mirror', dualM: 'Dual mirror', noM: 'no mirror',
      mirT: 'Mirror for this lens', mirMed: 'Medium', mirInc: 'included', mirLarge: 'Large',
      mirSharp: 'Sharp mirror, one size. Included.', mirDual: 'Dual mirror, Large. Included.', mirNone: 'No mirror. For driving and every day.',
      sizeCleared: 'New size: spare lenses and accessories were removed', seeAll: 'See all lenses', cancel: 'Cancel', addLens: 'Add lens', oneDisc: 'The discount covers one spare lens per pair. This one is full price.', added: 'added', removed: 'Removed', kitOn: 'Kit added', kitOff: 'Kit removed',
      orig: 'Original', sharpTag: 'Sharp', toMirror: 'for the spare lens',
      pNoMirror: function (tint) { return tint + ', no mirror'; }, pDrive: 'for driving and every day',
      pNose: 'Nosepad for the spare lens', pNoseWhy: 'so the lens is ready to use',
      pFloat: 'Float leash', pFloatWhy: 'floats if they go in the water', pNeck: 'neck and head', pNeckSeen: 'seen in the dark',
      pYellow: 'Yellow lens with mirror', pYellowWhy: 'lifts contrast in flat light',
      pClear: 'Clear lens with mirror', pClearWhy: 'overcast, dusk and rain',
      pPol: 'Polarized Smoke, dual mirror', pPolWhy: 'cuts glare off the water',
      pMir: 'Large mirror', pMirWhy: 'for the spare lens', pMirWide: 'a wider rear view', pRx: 'Rx insert frame', pRxWhy: 'for prescription'
    };
    var T = {
      no: {
        head: 'Din pakke', headSub: 'alt som legges i kurven', parts: 'deler', part: 'del',
        upgrade: 'Oppgrader til ', save: 'Spar', sep: 'Kjøpt hver for seg',
        why: 'Speil på veien. Speilfritt i bilen og i hverdagen.',
        rx: 'Bruker du styrkeglass? Bytt neseputen mot innsatsramme.', rxAdd: 'Bruker du styrkeglass? Legg til innsatsramme.',
        rxHow: 'Rammen festes bak glasset. Styrken slipes hos din optiker.',
        lensT: 'Reserveglass', lensD: 'Med eller uten speil', from: 'fra ', pctWith: ' med brillene',
        accT: 'Tilbehør', accD: 'Større speil, neseputer, neckwear', accDSharp: 'Neseputer, neckwear, innsatsramme', lensBtnD: 'Med eller uten speil',
        total: 'Totalt', youSave: 'Du sparer', edit: 'Endre', remove: 'Fjern',
        lensRow: 'Reserveglass', mirrorRow: 'Større speil', nosepadRow: 'Nesepute', insertRow: 'Innsatsramme', accRow: 'Tilbehør',
        mirName: function (size, side) { return size + ' speil, ' + side; }, fitBoth: 'Passer din brille og reserveglasset', fitGlasses: 'Passer din brille', fitSpare: 'Passer reserveglasset',
        chooseH: 'Reserveglass som passer ', sizeLine1: 'Vist i din størrelse, ', sizeLine2: '. Sharp og Original passer begge i innfatningen.',
        leftM: 'Left speil', rightM: 'Right speil', dualM: 'Dual speil', noM: 'uten speil',
        mirT: 'Speil til dette glasset', mirInc: 'følger med',
        mirSharp: 'Sharp-speil, én størrelse. Følger med.', mirDual: 'Dual speil, Large. Følger med.', mirNone: 'Uten speil. Til bil og hverdag.',
        sizeCleared: 'Ny størrelse: reserveglass og tilbehør ble fjernet', seeAll: 'Se alle glass', cancel: 'Avbryt', addLens: 'Legg til glass', oneDisc: 'Rabatten gjelder ett reserveglass per brille. Dette går til full pris.', added: 'lagt til', removed: 'Fjernet', kitOn: 'Kit lagt til', kitOff: 'Kit fjernet',
        toMirror: 'til reserveglasset',
        pNoMirror: function (tint) { return tint + ' uten speil'; }, pDrive: 'til bil og hverdag',
        pNose: 'Nesepute til reserveglasset', pNoseWhy: 'så glasset er klart til bruk',
        pFloat: 'Flyteholder', pFloatWhy: 'flyter om de faller i vannet', pNeck: 'hals og hode', pNeckSeen: 'synlig i mørket',
        pYellow: 'Yellow-glass med speil', pYellowWhy: 'løfter kontrasten i flatt lys',
        pClear: 'Clear-glass med speil', pClearWhy: 'gråvær, kveld og regn',
        pPol: 'Polarized Smoke med dobbelt speil', pPolWhy: 'mot gjenskinn fra vann',
        pMir: 'Large speil', pMirWhy: 'til reserveglasset', pMirWide: 'større utsyn bakover', pRx: 'Innsatsramme', pRxWhy: 'for styrkeglass'
      },
      de: {
        head: 'Dein Paket', headSub: 'alles, was in den Warenkorb kommt', parts: 'Teile', part: 'Teil',
        upgrade: 'Upgrade auf ', save: 'Spare', sep: 'Einzeln gekauft',
        why: 'Spiegel auf der Straße. Ohne Spiegel im Auto und im Alltag.',
        rx: 'Brillenträger? Tausche das Nasenpad-Set gegen den Einsatzrahmen.', rxAdd: 'Brillenträger? Füge den Einsatzrahmen hinzu.',
        rxHow: 'Der Rahmen sitzt hinter dem Glas. Dein Optiker schleift die Sehstärke ein.',
        lensT: 'Ersatzglas', lensD: 'Mit oder ohne Spiegel', from: 'ab ', pctWith: ' mit der Brille',
        accT: 'Zubehör', accD: 'Größerer Spiegel, Nasenpads, Neckwear', accDSharp: 'Nasenpads, Neckwear, Sehstärken-Einsatz', lensBtnD: 'Mit oder ohne Spiegel',
        total: 'Total', youSave: 'Du sparst', edit: 'Ändern', remove: 'Entfernen',
        lensRow: 'Ersatzglas', mirrorRow: 'Größerer Spiegel', nosepadRow: 'Nasenpad', insertRow: 'Sehstärken-Einsatz', accRow: 'Zubehör',
        mirName: function (size, side) { return size + ' Spiegel, ' + side; }, fitBoth: 'Passt zu deiner Brille und zum Ersatzglas', fitGlasses: 'Passt zu deiner Brille', fitSpare: 'Passt zum Ersatzglas',
        chooseH: 'Ersatzgläser für ', sizeLine1: 'In deiner Größe, ', sizeLine2: '. Sharp und Original passen beide in die Fassung.',
        leftM: 'Left Spiegel', rightM: 'Right Spiegel', dualM: 'Dual Spiegel', noM: 'ohne Spiegel',
        mirT: 'Spiegel für dieses Glas', mirInc: 'inklusive',
        mirSharp: 'Sharp Spiegel, eine Größe. Inklusive.', mirDual: 'Dual Spiegel, Large. Inklusive.', mirNone: 'Ohne Spiegel. Fürs Auto und den Alltag.',
        sizeCleared: 'Neue Größe: Ersatzgläser und Zubehör wurden entfernt', seeAll: 'Alle Gläser ansehen', cancel: 'Abbrechen', addLens: 'Glas hinzufügen', oneDisc: 'Der Rabatt gilt für ein Ersatzglas pro Brille. Dieses ist zum vollen Preis.', added: 'hinzugefügt', removed: 'Entfernt', kitOn: 'Kit hinzugefügt', kitOff: 'Kit entfernt',
        toMirror: 'für das Ersatzglas',
        pNoMirror: function (tint) { return tint + ', ohne Spiegel'; }, pDrive: 'fürs Auto und den Alltag',
        pNose: 'Nasenpad für das Ersatzglas', pNoseWhy: 'damit das Glas einsatzbereit ist',
        pFloat: 'Schwimmband', pFloatWhy: 'schwimmt, falls sie ins Wasser fallen', pNeck: 'Hals und Kopf', pNeckSeen: 'sichtbar im Dunkeln',
        pYellow: 'Yellow Glas mit Spiegel', pYellowWhy: 'mehr Kontrast bei flachem Licht',
        pClear: 'Clear Glas mit Spiegel', pClearWhy: 'bedeckt, Dämmerung und Regen',
        pPol: 'Polarized Smoke, Dual Spiegel', pPolWhy: 'gegen Blendung vom Wasser',
        pMir: 'Large Spiegel', pMirWhy: 'für das Ersatzglas', pMirWide: 'mehr Sicht nach hinten', pRx: 'Sehstärken-Einsatz', pRxWhy: 'für Sehstärke'
      },
      fr: {
        head: 'Votre pack', headSub: 'tout ce qui va dans le panier', parts: 'éléments', part: 'élément',
        upgrade: 'Passez à ', save: 'Économisez', sep: 'Achetés séparément',
        why: 'Miroir sur la route. Sans miroir en voiture et au quotidien.',
        rx: 'Vous portez des verres correcteurs ? Remplacez les plaquettes par l’insert.', rxAdd: 'Vous portez des verres correcteurs ? Ajoutez l’insert de correction.',
        rxHow: 'L’insert se place derrière le verre. Votre opticien y monte votre correction.',
        lensT: 'Verre de rechange', lensD: 'Avec ou sans miroir', from: 'à partir de ', pctWith: ' avec les lunettes',
        accT: 'Accessoires', accD: 'Miroir plus grand, plaquettes, neckwear', accDSharp: 'Plaquettes, neckwear, insert de correction', lensBtnD: 'Avec ou sans miroir',
        total: 'Total', youSave: 'Vous économisez', edit: 'Modifier', remove: 'Retirer',
        lensRow: 'Verre de rechange', mirrorRow: 'Miroir plus grand', nosepadRow: 'Plaquette nasale', insertRow: 'Insert de correction', accRow: 'Accessoire',
        mirName: function (size, side) { return 'Miroir ' + size + ', ' + side; }, fitBoth: 'Compatible avec vos lunettes et le verre de rechange', fitGlasses: 'Compatible avec vos lunettes', fitSpare: 'Compatible avec le verre de rechange',
        chooseH: 'Verres de rechange pour ', sizeLine1: 'Dans votre taille, ', sizeLine2: '. Sharp et Original s’adaptent tous deux à la monture.',
        leftM: 'miroir Left', rightM: 'miroir Right', dualM: 'miroir Dual', noM: 'sans miroir',
        mirT: 'Miroir pour ce verre', mirInc: 'inclus',
        mirSharp: 'Miroir Sharp, taille unique. Inclus.', mirDual: 'Miroir Dual, Large. Inclus.', mirNone: 'Sans miroir. Pour la voiture et le quotidien.',
        sizeCleared: 'Nouvelle taille : verres de rechange et accessoires retirés', seeAll: 'Voir tous les verres', cancel: 'Annuler', addLens: 'Ajouter le verre', oneDisc: 'La remise couvre un verre de rechange par paire. Celui-ci est au prix fort.', added: 'ajouté', removed: 'Retiré', kitOn: 'Kit ajouté', kitOff: 'Kit retiré',
        toMirror: 'pour le verre de rechange',
        pNoMirror: function (tint) { return tint + ', sans miroir'; }, pDrive: 'pour la voiture et le quotidien',
        pNose: 'Plaquette pour le verre de rechange', pNoseWhy: 'pour que le verre soit prêt à l’emploi',
        pFloat: 'Cordon flottant', pFloatWhy: 'flotte si elles tombent à l’eau', pNeck: 'cou et tête', pNeckSeen: 'visible dans le noir',
        pYellow: 'Verre Yellow avec miroir', pYellowWhy: 'renforce le contraste en lumière plate',
        pClear: 'Verre Clear avec miroir', pClearWhy: 'ciel couvert, crépuscule et pluie',
        pPol: 'Polarized Smoke, miroir Dual', pPolWhy: 'contre les reflets de l’eau',
        pMir: 'Miroir Large', pMirWhy: 'pour le verre de rechange', pMirWide: 'une vue arrière plus large', pRx: 'Insert de correction', pRxWhy: 'pour verres correcteurs'
      },
      it: {
        head: 'Il tuo pacchetto', headSub: 'tutto ciò che finisce nel carrello', parts: 'articoli', part: 'articolo',
        upgrade: 'Passa a ', save: 'Risparmia', sep: 'Acquistati separatamente',
        why: 'Specchio in strada. Senza specchio in auto e ogni giorno.',
        rx: 'Porti lenti da vista? Sostituisci i naselli con l’inserto.', rxAdd: 'Porti lenti da vista? Aggiungi l’inserto per correzione.',
        rxHow: 'L’inserto si monta dietro la lente. Il tuo ottico applica la tua correzione.',
        lensT: 'Lente di ricambio', lensD: 'Con o senza specchio', from: 'da ', pctWith: ' con gli occhiali',
        accT: 'Accessori', accD: 'Specchio più grande, naselli, neckwear', accDSharp: 'Naselli, neckwear, inserto per correzione', lensBtnD: 'Con o senza specchio',
        total: 'Total', youSave: 'Risparmi', edit: 'Modifica', remove: 'Rimuovi',
        lensRow: 'Lente di ricambio', mirrorRow: 'Specchio più grande', nosepadRow: 'Nasello', insertRow: 'Inserto per correzione', accRow: 'Accessorio',
        mirName: function (size, side) { return 'Specchio ' + size + ', ' + side; }, fitBoth: 'Compatibile con i tuoi occhiali e la lente di ricambio', fitGlasses: 'Compatibile con i tuoi occhiali', fitSpare: 'Compatibile con la lente di ricambio',
        chooseH: 'Lenti di ricambio per ', sizeLine1: 'Nella tua taglia, ', sizeLine2: '. Sharp e Original si adattano entrambe alla montatura.',
        leftM: 'specchio Left', rightM: 'specchio Right', dualM: 'specchio Dual', noM: 'senza specchio',
        mirT: 'Specchio per questa lente', mirInc: 'incluso',
        mirSharp: 'Specchio Sharp, taglia unica. Incluso.', mirDual: 'Specchio Dual, Large. Incluso.', mirNone: 'Senza specchio. Per l’auto e ogni giorno.',
        sizeCleared: 'Nuova taglia: lenti di ricambio e accessori rimossi', seeAll: 'Vedi tutte le lenti', cancel: 'Annulla', addLens: 'Aggiungi lente', oneDisc: 'Lo sconto copre una lente di ricambio per paio. Questa è a prezzo pieno.', added: 'aggiunta', removed: 'Rimosso', kitOn: 'Kit aggiunto', kitOff: 'Kit rimosso',
        toMirror: 'per la lente di ricambio',
        pNoMirror: function (tint) { return tint + ', senza specchio'; }, pDrive: 'per l’auto e ogni giorno',
        pNose: 'Nasello per la lente di ricambio', pNoseWhy: 'così la lente è pronta all’uso',
        pFloat: 'Cordino galleggiante', pFloatWhy: 'galleggia se cadono in acqua', pNeck: 'collo e testa', pNeckSeen: 'visibile al buio',
        pYellow: 'Lente Yellow con specchio', pYellowWhy: 'aumenta il contrasto con luce piatta',
        pClear: 'Lente Clear con specchio', pClearWhy: 'cielo coperto, crepuscolo e pioggia',
        pPol: 'Polarized Smoke, specchio Dual', pPolWhy: 'contro i riflessi dell’acqua',
        pMir: 'Specchio Large', pMirWhy: 'per la lente di ricambio', pMirWide: 'più visuale posteriore', pRx: 'Inserto per correzione', pRxWhy: 'per lenti da vista'
      },
      es: {
        head: 'Tu pack', headSub: 'todo lo que va al carrito', parts: 'artículos', part: 'artículo',
        upgrade: 'Cambia a ', save: 'Ahorra', sep: 'Comprados por separado',
        why: 'Espejo en carretera. Sin espejo en el coche y a diario.',
        rx: '¿Usas graduación? Cambia las almohadillas por el soporte.', rxAdd: '¿Usas graduación? Añade el soporte para graduación.',
        rxHow: 'El soporte va detrás de la lente. Tu óptico monta tu graduación.',
        lensT: 'Lente de repuesto', lensD: 'Con o sin espejo', from: 'desde ', pctWith: ' con las gafas',
        accT: 'Accesorios', accD: 'Espejo más grande, almohadillas, neckwear', accDSharp: 'Almohadillas, neckwear, soporte para graduación', lensBtnD: 'Con o sin espejo',
        total: 'Total', youSave: 'Ahorras', edit: 'Cambiar', remove: 'Quitar',
        lensRow: 'Lente de repuesto', mirrorRow: 'Espejo más grande', nosepadRow: 'Almohadilla nasal', insertRow: 'Soporte para graduación', accRow: 'Accesorio',
        mirName: function (size, side) { return 'Espejo ' + size + ', ' + side; }, fitBoth: 'Compatible con tus gafas y la lente de repuesto', fitGlasses: 'Compatible con tus gafas', fitSpare: 'Compatible con la lente de repuesto',
        chooseH: 'Lentes de repuesto para ', sizeLine1: 'En tu talla, ', sizeLine2: '. Sharp y Original encajan en la montura.',
        leftM: 'espejo Left', rightM: 'espejo Right', dualM: 'espejo Dual', noM: 'sin espejo',
        mirT: 'Espejo para esta lente', mirInc: 'incluido',
        mirSharp: 'Espejo Sharp, talla única. Incluido.', mirDual: 'Espejo Dual, Large. Incluido.', mirNone: 'Sin espejo. Para el coche y el día a día.',
        sizeCleared: 'Nueva talla: se quitaron las lentes de repuesto y los accesorios', seeAll: 'Ver todas las lentes', cancel: 'Cancelar', addLens: 'Añadir lente', oneDisc: 'El descuento cubre una lente de repuesto por par. Esta va a precio completo.', added: 'añadida', removed: 'Quitado', kitOn: 'Kit añadido', kitOff: 'Kit quitado',
        toMirror: 'para la lente de repuesto',
        pNoMirror: function (tint) { return tint + ', sin espejo'; }, pDrive: 'para el coche y el día a día',
        pNose: 'Almohadilla para la lente de repuesto', pNoseWhy: 'para que la lente esté lista',
        pFloat: 'Cordón flotante', pFloatWhy: 'flota si caen al agua', pNeck: 'cuello y cabeza', pNeckSeen: 'visible en la oscuridad',
        pYellow: 'Lente Yellow con espejo', pYellowWhy: 'realza el contraste con luz plana',
        pClear: 'Lente Clear con espejo', pClearWhy: 'nublado, atardecer y lluvia',
        pPol: 'Polarized Smoke, espejo Dual', pPolWhy: 'contra los reflejos del agua',
        pMir: 'Espejo Large', pMirWhy: 'para la lente de repuesto', pMirWide: 'más visión trasera', pRx: 'Soporte para graduación', pRxWhy: 'para graduación'
      }
    };
    var m = {}, k;
    for (k in en) m[k] = en[k];
    if (T[lang]) for (k in T[lang]) m[k] = T[lang][k];
    m.lang = lang; m.no = (lang === 'no');
    return m;
  })();
  /* Two configurators feed this module and they name their fields differently.
     The View exposes {lens, color, size, mirror}. The Clip has no frame colour
     and keeps the lens type in `color` ("Polarized Smoke Sharp"), with the bare
     tint in `baseLens`. Normalise both into the shape the kit rules expect and
     record which product we are on, so a Clip kit never matches on The View. */
  function readState() {
    try {
      if (typeof state === 'undefined' || !state) return null;
      if (typeof state.lens === 'undefined' && typeof state.baseLens !== 'undefined') {
        return { lens: String(state.color || ''), color: '', size: String(state.size || ''),
                 mirror: String(state.mirror || ''), product: 'clip' };
      }
      return { lens: String(state.lens || ''), color: String(state.color || ''),
               size: String(state.size || ''), mirror: String(state.mirror || ''), product: 'view' };
    } catch (e) { return null; }
  }
  function kitRule(s) {
    if (!s) return null;
    for (var i = 0; i < KITS.length; i++) {
      var k = KITS[i];
      /* a kit without its own size rule is an M · 145 kit, which is what every
         kit was before the S · 140 ones were added */
      var sizeOk = k.size ? k.size.test(s.size || '') : (!s.size || /^M|145/.test(s.size));
      /* a kit without an explicit product belongs to The View, which is where
         every kit lived before The Clip got its own */
      var prodOk = (k.product || 'view') === (s.product || 'view');
      if (prodOk && sizeOk && k.lens.test(s.lens) && k.color.test(s.color) && k.mirror.test(s.mirror)) return k;
    }
    return null;
  }

  /* v15.0 2026-09-24: a Sharp kit lists alternative variants (alts / rxAlts) that
     differ only in the mirror-free spare-lens colour (Blue/Purple/Gold, same price).
     The first one in stock is sold, so a kit only disappears when every colour is out. */
  function pickVar(main, alts) {
    if (!pricesLoaded) return main;
    var ids = [main].concat(alts || []);
    for (var i = 0; i < ids.length; i++) { var e = PRICES[ids[i]]; if (e && e.a) return ids[i]; }
    return main;
  }
  function kv(k) { return k ? pickVar(k.variant, k.alts) : null; }
  function krx(k) { return k && k.rxVariant ? pickVar(k.rxVariant, k.rxAlts) : null; }
  function matchKit(s) {
    if (!s || !pricesLoaded) return null;
    var k = kitRule(s);
    if (!k) return null;
    /* not fetched yet: ask for it and stay quiet until we know the real price */
    if (!PRICES[k.variant]) { ensureKit(k); return null; }
    if (PRICES[kv(k)] && PRICES[kv(k)].a) return k;
    /* a kit whose product is not published to the Online Store has no storefront
       price, and a kit that is sold out cannot be added either: never offer
       either one (the add-to-cart POST would fail) */
    return null;
  }
  function fxRatio() {
    try {
      var f = document.querySelector('form[action*="/cart/add"]');
      var vid = f && parseInt((f.querySelector('[name="id"]') || {}).value, 10);
      var jsP = vid && PRICES[vid] && PRICES[vid].p;
      var liveP = Number(window.currentVariantPrice);
      if (jsP > 0 && liveP > 0) {
        var r = liveP / jsP;
        if (r > 0.2 && r < 2000) return r;
      }
    } catch (e) {}
    return 1;
  }
  function glassesPrice() {
    try { var c = Number(window.currentVariantPrice); if (c > 0) return c; } catch (e) {}
    try {
      var f = document.querySelector('form[action*="/cart/add"]');
      var vid = f && parseInt((f.querySelector('[name="id"]') || {}).value, 10);
      if (vid && PRICES[vid]) return PRICES[vid].p;
    } catch (e) {}
    return null;
  }
  /* The theme's build state, read the way its own updateConfig reads it:
     selectedAddons (active accessory cards) + window._lensPickerSelection
     (lens / nosepad / mirror from the lens drawer). Returned in cents. */
  function extrasCents() {
    var cur = 0, orig = 0;
    try {
      var sa = (typeof selectedAddons !== 'undefined' && selectedAddons) ? selectedAddons : [];
      for (var i = 0; i < sa.length; i++) {
        var a = sa[i], q = Math.max(1, parseInt(a.quantity, 10) || 1);
        var c = (typeof a.currentCents === 'number') ? a.currentCents : (parseFloat(a.price) || 0);
        var o = (typeof a.originalCents === 'number') ? a.originalCents : c;
        cur += c * q; orig += o * q;
      }
    } catch (e) {}
    try {
      var sel = window._lensPickerSelection;
      if (sel) {
        var lc = (typeof sel.lensCents === 'number') ? sel.lensCents : (sel.totalCents || 0);
        var lo = (typeof sel.lensOriginalCents === 'number') ? sel.lensOriginalCents : lc;
        var np = (sel.nosepad && typeof sel.nosepad.cents === 'number') ? sel.nosepad.cents : 0;
        var mi = (sel.mirror && typeof sel.mirror.cents === 'number') ? sel.mirror.cents : 0;
        cur += lc + np + mi; orig += lo + np + mi;
      }
    } catch (e) {}
    return { cur: cur, orig: orig };
  }
  function productQty() {
    try { if (typeof getProductQuantity === 'function') return Math.max(1, parseInt(getProductQuantity(), 10) || 1); } catch (e) {}
    try {
      var f = document.querySelector('form[action*="/cart/add"]');
      var q = f && f.querySelector('[name="quantity"]');
      return Math.max(1, parseInt(q && q.value, 10) || 1);
    } catch (e) { return 1; }
  }
  function kitTotals() {
    var isRx = (choice === 'rx');
    var unit = isRx ? kitCents(krx(current), current.rxNum) : kitCents(kv(current), current.num);
    var cmpU = isRx ? kitCompareCents(krx(current), current.rxWas) : kitCompareCents(kv(current), current.was);
    var q = productQty(), x = extrasCents();
    var total = unit * q + x.cur;
    var origT = Math.max(cmpU, unit) * q + x.orig;
    return { total: total, save: Math.max(0, origT - total), unit: unit, cmp: cmpU };
  }
  function rxPurchasable(kit) { return !!(kit && kit.rxVariant && (!pricesLoaded || (PRICES[krx(kit)] && PRICES[krx(kit)].a))); }
  function findAtcButton() {
    var f = document.querySelector('form[action*="/cart/add"]');
    if (!f) return null;
    return f.querySelector('[type="submit"]') ||
           [].slice.call(f.querySelectorAll('button')).filter(function (b) { return b.type !== 'button'; })[0];
  }

  var current = null;      /* matched kit for the current build */
  var choice = 'glasses';  /* 'glasses' | 'kit' | 'rx' — v6: GLASSES is the default (see header) */
  var seen = {};
  var exposureLogged = false;
  var lastWritten = null;  /* the exact label we last wrote — detects theme rewrites */

  function themeRepaintAtc() {
    try { if (typeof window.__tkcOrigUpdateConfig === 'function') window.__tkcOrigUpdateConfig(); } catch (e) {}
  }
  function setAtcLabel() {
    var btn = findAtcButton();
    if (!btn) return;
    var priceEl = btn.querySelector('[data-button-price]');
    if (!priceEl) return;
    if (current && (choice === 'kit' || choice === 'rx')) {
      /* same shape as the theme's own button price: main x qty + every extra */
      var want = money(kitTotals().total);
      if (priceEl.textContent.trim() !== want) priceEl.textContent = want;
      lastWritten = want;
    } else {
      lastWritten = null;
      /* glasses chosen: button = glasses x qty + every extra, the theme's own formula
         (v8: writing the bare glasses price here overwrote the theme's total after a lens was added) */
      var gpNow = glassesPrice();
      if (gpNow) {
        var x = extrasCents();
        var wantG = money(gpNow * productQty() + x.cur);
        if (priceEl.textContent.trim() !== wantG) priceEl.textContent = wantG;
      }
    }
    syncBuild();
  }

  /* ---- "Your build" header + sticky build drawer (unchanged from v5) ---- */
  var buildObs = null;
  function buildNodes() {
    return {
      price: document.querySelector('.config-price'),
      total: document.querySelector('.trieye-build-drawer__total-value'),
      save:  document.querySelector('.trieye-build-drawer__savings-value'),
      items: document.querySelector('.trieye-build-drawer__items'),
      list:  document.querySelector('.config-items'),
      sub:   document.querySelector('.config-row--subtotal .config-val')
    };
  }
  /* German capitalises every noun, so the mid-sentence lowercasing that reads
     naturally in the other five languages is wrong there: leave it alone. */
  function lower1(s) { return (!s || L.lang === 'de' || /^Rx\b/.test(s)) ? s : s.charAt(0).toLowerCase() + s.slice(1); }
  function kitParts(kit, isRx) {
    var src = isRx
      ? shortLine(kit.line.replace(/,? (and )?(an extra )?nosepad(s| set)?/i, '')
                          .replace(/^Adds (a |the )?/, 'Adds the Rx insert, '))
      : shortLine(kit.line);
    return src.split(/,\s*/).filter(Boolean);
  }
  function cap1(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }
  var themeBuild = { price: null, total: null, save: null, items: null, sub: null };
  var buildCaptured = false;
  function captureBuild(n) {
    if (n.price) themeBuild.price = n.price.textContent;
    if (n.total) themeBuild.total = n.total.textContent;
    if (n.save)  themeBuild.save  = n.save.textContent;
    if (n.items) { var tmpI = document.createElement('ul'); tmpI.innerHTML = n.items.innerHTML; [].slice.call(tmpI.querySelectorAll('.tkc-build-line')).forEach(function (x) { x.parentNode.removeChild(x); }); themeBuild.items = tmpI.innerHTML; }
    if (n.sub)   themeBuild.sub   = n.sub.textContent;
    buildCaptured = true;
  }
  function syncBuild() {
    var n = buildNodes();
    if (!n.price) return;
    var kitOn = !!(current && (choice === 'kit' || choice === 'rx'));
    if (!kitOn && !buildCaptured) return;
    if (buildObs) buildObs.disconnect();
    try {
      if (kitOn) {
        if (!buildCaptured) captureBuild(n);
        var isRx = (choice === 'rx');
        var kt = kitTotals();
        n.price.textContent = money(kt.total);
        if (n.total) n.total.textContent = money(kt.total);
        if (n.save)  n.save.textContent = kt.save > 0 ? money(kt.save) : '';
        if (n.items) {
          /* the theme lists glasses first, then lens / nosepad / mirror / accessory
             rows. Replace only the glasses line with the kit; keep the rest. */
          var tmp = document.createElement('ul');
          tmp.innerHTML = themeBuild.items || '';
          var kitLi = document.createElement('li');
          kitLi.className = 'trieye-build-drawer__item tkc-build-line';
          kitLi.innerHTML = '<span>' + current.title + (isRx ? ' (Prescription)' : '') + '</span>' +
                            '<span>' + money(kt.unit * productQty()) + '</span>';
          var first = tmp.querySelector('li');
          if (first) tmp.replaceChild(kitLi, first); else tmp.appendChild(kitLi);
          n.items.innerHTML = tmp.innerHTML;
        }
        if (n.list) {
          var old = n.list.querySelectorAll('.tkc-kit-row, .tkc-kit-label');
          for (var i = 0; i < old.length; i++) { old[i].parentNode.removeChild(old[i]); }
          var rows = '<div class="config-section-label tkc-kit-label">' +
            current.title + (isRx ? ' (Prescription)' : '') + '</div>' +
            kitParts(current, isRx).map(function (part) {
              return '<div class="config-row tkc-kit-row">' +
                '<span class="config-key">' + cap1(part) + '</span>' +
                '<span class="config-val">Included</span></div>';
            }).join('');
          var subRow = n.list.querySelector('.config-row--subtotal');
          if (subRow) { subRow.insertAdjacentHTML('beforebegin', rows); }
          else { n.list.insertAdjacentHTML('beforeend', rows); }
        }
        if (n.sub) n.sub.textContent = money(kt.total);
        try {
          var subOrig = document.querySelector('.config-row--subtotal .config-val-orig');
          if (subOrig) { if (kt.save > 0) subOrig.textContent = money(kt.total + kt.save); else subOrig.style.display = 'none'; }
          var saveRow = document.querySelector('.config-items [data-savings-row] .config-val');
          if (saveRow) saveRow.textContent = money(kt.save);
          var saveRowEl = document.querySelector('.config-items [data-savings-row]');
          if (saveRowEl) saveRowEl.style.display = kt.save > 0 ? '' : 'none';
        } catch (e) {}
      } else {
        if (themeBuild.price !== null) n.price.textContent = themeBuild.price;
        if (n.total && themeBuild.total !== null) n.total.textContent = themeBuild.total;
        if (n.save && themeBuild.save !== null) n.save.textContent = themeBuild.save;
        if (n.items && themeBuild.items !== null) n.items.innerHTML = themeBuild.items;
        if (n.list) {
          var mine = n.list.querySelectorAll('.tkc-kit-row, .tkc-kit-label');
          for (var j = 0; j < mine.length; j++) { mine[j].parentNode.removeChild(mine[j]); }
        }
        if (n.sub && themeBuild.sub !== null) n.sub.textContent = themeBuild.sub;
        buildCaptured = false;
      }
    } catch (e) {}
    if (buildObs) startBuildObserver();
  }
  function startBuildObserver() {
    var header = document.querySelector('.config-accordion') || document.querySelector('.config-header');
    var panel = document.querySelector('.trieye-build-drawer__panel');
    if (!header && !panel) return;
    if (!buildObs) {
      buildObs = new MutationObserver(function () {
        /* we disconnect while writing, so anything observed is the THEME's repaint:
           re-take its baseline (it may now hold a lens or accessory row), then re-apply ours */
        var n = buildNodes();
        captureBuild(n);
        if (current && (choice === 'kit' || choice === 'rx')) syncBuild();
      });
    }
    var opt = { childList: true, subtree: true, characterData: true };
    if (header) buildObs.observe(header, opt);
    if (panel) buildObs.observe(panel, opt);
  }

  /* Kit chosen: swap the cart form's variant to the kit and let the THEME's own
     submit handler run. Its addToCartWithAddons() folds the main item, the
     active accessory cards and the lens-drawer items into ONE atomic
     /cart/add.js POST - which is exactly what v7.0 lost by posting the kit
     itself (spare lens chosen with a kit never reached the cart). With the
     default 'glasses' choice this handler returns immediately. */
  var swapTimer = null, swapGlassesVid = null, inSwap = false;
  function restoreFormVid(vid) {
    try {
      var f = document.querySelector('form[action*="/cart/add"]');
      var idEl = f && f.querySelector('[name="id"]');
      if (idEl && vid && String(idEl.value) !== String(vid)) idEl.value = vid;
    } catch (e) {}
  }
  if (!window.__tkcClickWired) {
    window.__tkcClickWired = true;
    document.addEventListener('click', function (e) {
      if (!current || choice === 'glasses') return;
      var btn = e.target && e.target.closest && e.target.closest('button, [type="submit"]');
      if (!btn) return;
      var isDrawerBuy = btn.className && /trieye-build-drawer__cart/.test(btn.className);
      var form = document.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      if (!isDrawerBuy) {
        var inForm = btn.closest && btn.closest('form[action*="/cart/add"]');
        if (!inForm || btn.type === 'button') return;
      }
      var idEl = form.querySelector('[name="id"]');
      if (!idEl) return;
      if (inSwap) { e.preventDefault(); e.stopImmediatePropagation(); return; }   /* a second click while the first add is in flight */
      inSwap = true;
      var glassesVid = idEl.value; swapGlassesVid = glassesVid;
      var kitVid = (choice === 'rx') ? krx(current) : kv(current);
      idEl.value = kitVid;
      track('tri_kit_match_click', { kit: current.key + (choice === 'rx' ? '-rx' : ''), extras: extrasCents().cur });
      /* hand the variant back to the theme once the cart has changed (or after
         a generous timeout, if the add failed) so the page state stays sane */
      var restored = false;
      function done() { if (restored) return; restored = true; clearTimeout(swapTimer); setTimeout(function () { restoreFormVid(swapGlassesVid); inSwap = false; }, 300); }
      document.addEventListener('theme:cart:change', done, { once: true });
      swapTimer = setTimeout(done, 6000);
      if (isDrawerBuy) {
        /* the sticky drawer's button sits outside the form: submit the form
           ourselves so the theme's submit handler (and its cleanup) runs */
        e.preventDefault(); e.stopImmediatePropagation();
        try { if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true })); } catch (err) {}
      }
      /* in-form button: let the click become a normal submit */
    }, true);
  }

  function shortLine(s) {
    var t = s.replace(/^Adds (a |the |an )?/i, '')
             .replace(/\ban extra nosepad set\b/i, 'an extra nosepad set@')
             .replace(/\bnosepad set\b(?!@)/i, 'nosepads')
             .replace(/\ban extra nosepad set@/i, 'an extra nosepad set')
             .replace(/,? and /i, ', ')
             .replace(/, a /g, ', ')
             .replace(/\bmatching /i, '')
             .replace(/\bfloat retainer\b/i, 'float leash')
             .replace(/\.$/, '');
    return t.charAt(0).toUpperCase() + t.slice(1);
  }
  function glassesShot() {
    try {
      var im = document.querySelector('.px-btn.active .px-img') ||
               document.querySelector('.trieye-gallery__main img, .product__media__wrapper img');
      if (im && im.src) return im.src;
    } catch (e) {}
    return '';
  }
  /* one entry per component image: short name + one-line WHY. Colour names
     are product option values and stay in English in every locale. */
  function partInfo(src) {
    var lens = function (tint) { return { name: L.pNoMirror(tint), why: L.pDrive }; };
    if (src === IMG.nose)   return { name: L.pNose, why: L.pNoseWhy };
    if (src === IMG.flt)    return { name: L.pFloat, why: L.pFloatWhy };
    if (src === IMG.hc)     return lens('High Contrast');
    if (src === IMG.blue)   return lens('Blue');
    if (src === IMG.gold)   return lens('Gold');
    if (src === IMG.purple) return lens('Purple');
    if (src === IMG.nwBW)   return { name: 'Neckwear Black & White', why: L.pNeck };
    if (src === IMG.nwWB)   return { name: 'Neckwear White & Black', why: L.pNeck };
    if (src === IMG.nwRB)   return { name: 'Neckwear Red & Black', why: L.pNeck };
    if (src === IMG.nwOB)   return { name: 'Neckwear Warm Orange & Black', why: L.pNeckSeen };
    if (src === IMG.yellowL || src === IMG.yellowR) return { name: L.pYellow, why: L.pYellowWhy };
    if (src === IMG.clearL || src === IMG.clearR || src === IMG.clearD) return { name: L.pClear, why: L.pClearWhy };
    if (src === IMG.polD)   return { name: L.pPol, why: L.pPolWhy };
    if (src === IMG.mirL || src === IMG.mirR) return { name: L.pMir, why: L.pMirWhy };
    if (src === IMG.mirLc || src === IMG.mirRc) return { name: L.pMir, why: L.pMirWide };
    if (src === RX.img)     return { name: L.pRx, why: L.pRxWhy };
    return { name: '', why: '' };
  }
  function lower1x(str) { return (str && L.lang !== 'de') ? str.charAt(0).toLowerCase() + str.slice(1) : str; }
  function esc(str) { return String(str == null ? '' : str).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var CHECK = '<svg viewBox="0 0 12 12"><path d="M2 6.5l2.6 2.6L10 3.5"/></svg>';

  /* ---- recommendation table (6 399 paid orders, Mar-Sep 2026): main lens -> spare tints ---- */
  var COMBO = {"Photochromic Smoke 0–3 Sharp": ["Reflective Gold Sharp", "Clear", "Reflective Blue", "Polarized Smoke", "Yellow", "Photochromic Full Spectrum Smoke 0-3", "Smoke", "Reflective Red"], "Photochromic Smoke 0–3": ["Clear", "Reflective Blue", "Yellow", "Reflective Red", "Polarized Smoke", "Photochromic Full Spectrum Smoke 0-3", "Reflective Silver Sharp", "Photochromatic Smoke 0-2"], "Reflective Red": ["Yellow", "Reflective Blue", "Clear", "Smoke", "High Contrast Smoke", "Reflective Red", "Photochromic Full Spectrum Smoke 0-3", "Photochromatic Smoke 0-2"], "High Contrast Smoke Sharp": ["Clear", "Reflective Blue Sharp", "Yellow", "Polarized Smoke", "Reflective Silver Sharp", "Photochromic Full Spectrum Smoke 0-3", "Reflective Blue", "Reflective Red"], "High Contrast Smoke": ["Clear", "Yellow", "Smoke", "Reflective Blue", "Reflective Red", "Photochromatic Smoke 0-2", "Polarized Smoke", "Photochromic Full Spectrum Smoke 0-3"], "Standard Smoke": ["Clear", "Yellow", "Reflective Red", "Photochromic Full Spectrum Smoke 0-3", "Reflective Gold Sharp", "Polarized Smoke"], "Standard Clear": ["Polarized Smoke", "Reflective Blue", "Photochromic Full Spectrum Smoke 0-3", "Clear"], "Polarized Smoke": ["Clear", "Yellow", "Reflective Blue", "Photochromic Full Spectrum Smoke 0-3", "Polarized Smoke", "Smoke", "Photochromatic Smoke 0-2", "High Contrast Smoke"], "Reflective Blue": ["Clear", "Polarized Smoke", "Smoke", "Photochromic Full Spectrum Smoke 0-3", "Reflective Red", "Reflective Blue", "Reflective Silver Sharp"], "Photochromic Smoke 0–2": ["Yellow", "Reflective Blue", "Smoke", "Polarized Smoke", "Reflective Red", "High Contrast Smoke"], "Reflective Rosè": ["Clear", "Photochromic Full Spectrum Smoke 0-3", "Yellow", "High Contrast Smoke", "Smoke", "Reflective Red", "Polarized Smoke"], "Reflective Blue Sharp": ["Clear", "Reflective Purple Sharp", "High Contrast Smoke Sharp", "Yellow", "Reflective Red", "Photochromic Full Spectrum Smoke 0-3", "Reflective Blue Sharp"], "Reflective Silver Sharp": ["Reflective Gold Sharp", "Reflective Silver Sharp", "Photochromic Smoke 0–3 Sharp", "Yellow", "Clear", "Reflective Blue Sharp"], "Polarized Smoke Sharp": ["Reflective Blue Sharp", "High Contrast Smoke Sharp", "Photochromic Full Spectrum Smoke 0-3", "Reflective Red", "Reflective Purple Sharp", "Polarized Smoke"]};
  var BEST = ["Clear", "Yellow", "Reflective Blue", "Photochromic Full Spectrum Smoke 0-3", "Polarized Smoke", "Smoke", "Reflective Red", "Reflective Gold Sharp", "Reflective Silver Sharp", "High Contrast Smoke"];
  var SHARP_PCT = 15;
  function origPct() { try { var p = parseInt(window._lensDiscountPct, 10); if (p > 0) return p; } catch (e) {} return 30; }
  function isSharpTint(t) { return /Sharp/i.test(t); }
  function sideOf(mirror) { var m = String(mirror || '').toLowerCase(); return m.indexOf('dual') >= 0 ? 'Dual' : (m.indexOf('right') >= 0 || m.indexOf('uk') >= 0) ? 'Right' : 'Left'; }
  function sizeStr(size) { return /140|^S/.test(String(size || '')) ? '140' : '145'; }
  function sideLabel(kind) { return kind === 'W/O' ? L.noM : kind === 'Dual' ? L.dualM : kind === 'Right' ? L.rightM : L.leftM; }
  function imgUrl(src, w) { if (!src) return ''; src = src.replace(/^\/\//, 'https://'); return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=' + (w || 220); }
  function findLensVariant(tint, sideKind, size) {
    if (!LENSPROD) return null;
    var sideStr = sideKind === 'W/O' ? 'W/O' : sideKind + ' Mirror';
    return LENSPROD.variants.filter(function (v) {
      return v.available && v.title.indexOf(tint + ' /') === 0 && v.title.indexOf(sideStr) >= 0 && v.title.indexOf(size) >= 0;
    })[0] || null;
  }
  /* six lenses that fit: recommended tints for the main lens, then best-sellers; customer's
     side for Original tints, W/O first for Sharp tints; only variants in the customer's size */
  function sixLenses(st) {
    var side = sideOf(st.mirror), size = sizeStr(st.size);
    var tints = (COMBO[st.lens] || []).concat(BEST), seen = {}, out = [];
    for (var i = 0; i < tints.length && out.length < 6; i++) {
      var t = tints[i]; if (seen[t]) continue; seen[t] = 1;
      var kinds = isSharpTint(t) ? ['W/O', side] : [side];
      for (var k = 0; k < kinds.length && out.length < 6; k++) {
        var v = findLensVariant(t, kinds[k], size);
        if (!v) continue;
        var pct = isSharpTint(t) ? SHARP_PCT : origPct();
        out.push({ tint: t, kind: kinds[k], v: v, orig: v.price, price: Math.round(v.price * (100 - pct) / 100), pct: pct,
                   img: imgUrl(v.featured_image && v.featured_image.src), gen: isSharpTint(t) ? 'sharp' : 'orig' });
        break;   /* one variant per tint */
      }
    }
    return out;
  }
  function largeMirror(side) {
    if (!MIRPROD || side === 'Dual') return null;
    return MIRPROD.variants.filter(function (v) { return v.available && /Large/.test(v.title) && v.title.indexOf(side) === 0; })[0] || null;
  }
  function glassesName(st) {
    var sharp = /Sharp/i.test(st.lens || '');
    if ((st.product || 'view') === 'clip') return sharp ? L.clipSharp : L.clip;
    return sharp ? L.sharp : L.glasses;
  }
  function glassesSub(st) { return [st.lens, st.color, String(st.mirror || '').replace(/ Mirror.*$/, ''), st.size].filter(Boolean).join(' · '); }

  /* ---- prescription insert: follow the frame colour ----
     The theme's lens drawer and accessory card always pick the Black insert. In
     arm B we swap the variant to the customer's frame colour (Medium only; Small
     exists in Black alone) before it reaches the build and the cart. */
  var INSERT = { '39759775858731': ['Medium', 'Black'], '39774888493099': ['Small', 'Black'], '44525968785451': ['Medium', 'Matte White'],
                 '44525968818219': ['Medium', 'Matte Olive'], '44525968850987': ['Medium', 'Crystal Violet'] };
  function insertFor(size, color) {
    var sz = sizeStr(size) === '140' ? 'Small' : 'Medium', want = null, black = null;
    for (var id in INSERT) { if (INSERT[id][0] !== sz) continue; if (INSERT[id][1] === color) want = id; if (INSERT[id][1] === 'Black') black = id; }
    return want || black;
  }
  function isInsertId(id) { return !!INSERT[String(id)]; }
  function fixInsertColour(st) {
    var changed = false;
    try {
      var sel = window._lensPickerSelection;
      var lists = sel ? [sel.items || []].concat((sel._tkcLenses || []).map(function (e) { return e.items; })) : [];
      lists.forEach(function (arr) { arr.forEach(function (it) {
        if (!isInsertId(it.id)) return;
        var want = insertFor(st.size, st.color);
        if (want && String(it.id) !== want) { it.id = parseInt(want, 10); changed = true; }
        if (sel.nosepad) sel.nosepad.name = INSERT[String(it.id)][1] + ' · ' + INSERT[String(it.id)][0];
      }); });
    } catch (e) {}
    try {
      [].slice.call(document.querySelectorAll('.addon-card.active[data-variant-id]')).forEach(function (c) {
        if (!isInsertId(c.dataset.variantId)) return;
        var want = insertFor(st.size, st.color);
        if (want && String(c.dataset.variantId) !== want) { c.dataset.variantId = want; changed = true; }
      });
      if (changed && typeof syncSelectedAddons === 'function') syncSelectedAddons();
    } catch (e) {}
    return changed;
  }
  /* ---- replacement mirror: name, image and what it fits ---- */
  function mirrorVariant(vid) { if (!MIRPROD) return null; return MIRPROD.variants.filter(function (v) { return String(v.id) === String(vid); })[0] || null; }
  function isMirrorId(vid) { return !!mirrorVariant(vid); }
  function mirrorInfo(vid) {
    var v = mirrorVariant(vid); if (!v) return null;
    var t = v.title || '';   /* "Left (US and Europe) Large" */
    var side = /^Right/i.test(t) ? 'Right' : 'Left', size = /Large/i.test(t) ? 'Large' : 'Medium';
    return { name: L.mirName(size, side), img: imgUrl(v.featured_image && v.featured_image.src, 120), side: side, size: size };
  }
  /* v15.3: the plain nosepad product (colourways Black / Matte White / Matte Olive / Crystal Violet) */
  function nosepadVariant(vid) { if (!NOSEPROD) return null; return NOSEPROD.variants.filter(function (v) { return String(v.id) === String(vid); })[0] || null; }
  function nosepadInfo(vid) {
    var v = nosepadVariant(vid); if (!v) return null;
    var t = String(v.title || '').trim(); if (!t || t === 'Default Title') t = 'Black';
    return { color: t, img: imgUrl(v.featured_image && v.featured_image.src, 120) };
  }
  /* an Original mirror fits Original glasses and Original spare lenses; a Sharp frame takes none of them */
  function mirrorFitText(st, forSpare) {
    var frameOrig = !/Sharp/i.test(st.lens || '');
    var spareOrig = lensEntries().some(function (e) { return !/Sharp/i.test(e.label || ''); });
    if (forSpare) return frameOrig ? L.fitBoth : L.fitSpare;
    if (frameOrig && spareOrig) return L.fitBoth;
    if (frameOrig) return L.fitGlasses;
    return spareOrig ? L.fitSpare : L.fitGlasses;
  }
  /* ---- theme state helpers ---- */
  function themeSel() { return window._lensPickerSelection || null; }
  function themeAddons() { try { return (typeof selectedAddons !== 'undefined' && selectedAddons) ? selectedAddons : []; } catch (e) { return []; } }
  function cardFor(vid) { return document.querySelector('.addon-card.active[data-variant-id="' + vid + '"]'); }
  function themeUpdate() { try { if (typeof window.updateConfig === 'function') window.updateConfig(); } catch (e) {} }
  function removeAddon(vid) {
    var c = cardFor(vid); if (c) c.classList.remove('active');
    try { if (typeof syncSelectedAddons === 'function') syncSelectedAddons(); else themeUpdate(); } catch (e) { themeUpdate(); }
    toast(L.removed);
  }
  /* Several spare lenses. Our list lives on the theme's selection object (_tkcLenses);
     the theme-shaped fields are rebuilt from it so the theme's price maths, build
     drawer and cart POST keep working. A selection made in the theme's own drawer
     (no _tkcLenses) is adopted as entry 1. */
  /* The theme's drawer writes ONE selection and overwrites the previous one. We
     keep what was there and add the new pick as another lens. v15.2: every pick
     is its own entry — the drawer remembers the last swatch, so "+ Spare lens →
     Add" a second time used to REPLACE the first lens instead of adding one.
     After the first lens the cart gives no discount, so the later ones are
     carried at full price. */
  var lastEntries = [], adoptSeq = 0;
  /* v15.4: with a kit in the package the cart's one-discounted-lens is already taken by the kit,
     so every extra lens is carried at full price. Without a kit: first lens discounted, as before. */
  function kitOn() { return !!(current && (choice === 'kit' || choice === 'rx')); }
  function repriceEntries(entries) {
    var off = kitOn();
    entries.forEach(function (e, i) { var pf = e.pctFirst || 0; e.pct = (i === 0 && !off) ? pf : 0; if (e.orig) e.price = Math.round(e.orig * (100 - e.pct) / 100); });
    return entries;
  }
  function syncEntriesFromTheme() {
    var sel = themeSel();
    if (!sel) { lastEntries = []; return; }
    if (sel._tkcLenses) { lastEntries = sel._tkcLenses; return; }
    if (!(sel.items && sel.items.length)) return;
    var vid = String(sel.items[0].id);
    var adopted = { key: 'theme:' + vid + ':' + (++adoptSeq), items: sel.items.slice(), label: sel.lensLabel || sel.label || '', price: sel.lensCents || sel.totalCents || 0, orig: sel.lensOriginalCents || (sel.lensCents || 0), pct: sel.lensDiscountPct || 0, pctFirst: sel.lensDiscountPct || (isSharpTint(sel.lensLabel || sel.label || '') ? SHARP_PCT : origPct()), img: sel.lensImage || '', nosepad: sel.nosepad || null, mirror: sel.mirror || null };
    var entries = lastEntries.slice();
    entries.push(adopted);
    repriceEntries(entries);
    rebuildThemeSel(entries);
    lastEntries = entries;
  }
  function lensEntries() {
    var sel = themeSel(); if (!sel) return [];
    if (sel._tkcLenses) return sel._tkcLenses;
    if (sel.items && sel.items.length) {
      return [{ key: 'theme:' + sel.items[0].id, items: sel.items.slice(), label: sel.lensLabel || sel.label || '', price: sel.lensCents || sel.totalCents || 0, orig: sel.lensOriginalCents || (sel.lensCents || 0), pct: sel.lensDiscountPct || 0, img: sel.lensImage || '', nosepad: sel.nosepad || null, mirror: sel.mirror || null }];
    }
    return [];
  }
  function rebuildThemeSel(entries) {
    if (!entries.length) { window._lensPickerSelection = null; return; }
    var items = [], lc = 0, lo = 0, mir = null, np = null, labels = [], npc = 0, npCents = 0;
    entries.forEach(function (e) { items = items.concat(e.items); lc += e.price; lo += e.orig || e.price; labels.push(e.label); if (e.mirror) mir = mir ? { name: mir.name + ' + ' + e.mirror.name, cents: mir.cents + e.mirror.cents, image: mir.image } : { name: e.mirror.name, cents: e.mirror.cents, image: e.mirror.image }; if (e.nosepad && typeof e.nosepad.cents === 'number') { npc++; npCents += e.nosepad.cents; if (!np) np = e.nosepad; } });
    /* v15.2: one nosepad per lens that asked for one — the theme's single `nosepad` slot carries the SUM, so the total matches what the cart charges */
    if (np) np = { name: np.name + (npc > 1 ? ' × ' + npc : ''), cents: npCents, image: np.image };
    var lab = labels.join(' + ');
    window._lensPickerSelection = { items: items, label: lab, lensLabel: lab, totalCents: lc + (mir ? mir.cents : 0) + (np ? np.cents : 0), lensCents: lc, lensOriginalCents: lo,
      lensDiscountPct: lo > lc ? Math.round((1 - lc / lo) * 100) : 0, lensImage: entries[0].img, nosepad: np, nosepadImage: np ? np.image : '', mirror: mir, _tkc: true, _tkcLenses: entries };
  }
  function selectLens(o, mirV, side) {
    var entries = lensEntries().slice();
    var items = [{ id: o.v.id, quantity: 1 }], mirror = null;
    if (mirV) { items.push({ id: mirV.id, quantity: 1, properties: { '_addon': 'true' } }); mirror = { name: L.mirLarge + ', ' + side, cents: mirV.price, image: imgUrl(mirV.featured_image && mirV.featured_image.src) }; }
    entries.push({ key: 'lens:' + o.v.id + ':' + Date.now(), items: items, label: o.tint + ' · ' + sideLabel(o.kind), price: o.price, orig: o.orig, pct: o.pct, pctFirst: o.pctFirst || o.pct, img: o.img, nosepad: null, mirror: mirror });
    repriceEntries(entries);
    rebuildThemeSel(entries); lastEntries = entries;
    themeUpdate();
    toast(L.lensT + ' ' + L.added);
  }
  /* v15.3: the nosepad (or insert) that came with a drawer lens can be dropped on its own */
  function removeNosepadEntry(key) {
    var base = key.slice(0, -3);
    var entries = lensEntries().map(function (e) {
      if (e.key !== base) return e;
      var c = {}; for (var f in e) c[f] = e[f];
      c.items = e.items.filter(function (it, i) { return i === 0 || isMirrorId(it.id); });   /* keep the lens and its mirror */
      c.nosepad = null; return c;
    });
    rebuildThemeSel(entries); lastEntries = entries;
    themeUpdate();
    toast(L.removed);
  }
  function removeLensEntry(key) {
    var entries = lensEntries().filter(function (e) { return e.key !== key; });
    /* after a removal the FIRST lens is the discounted one again (unless a kit is on) */
    repriceEntries(entries);
    rebuildThemeSel(entries); lastEntries = entries;
    themeUpdate();
    toast(L.removed);
  }
  /* ---- toast + count-up ---- */
  function toast(txt) {
    var el = document.getElementById('tri-kit-toast');
    if (!el) { el = document.createElement('div'); el.id = 'tri-kit-toast'; el.innerHTML = '<svg width="14" height="14" viewBox="0 0 12 12" style="stroke:currentColor;fill:none;stroke-width:2.2;stroke-linecap:round;stroke-linejoin:round"><path d="M2 6.5l2.6 2.6L10 3.5"/></svg><span></span>'; document.body.appendChild(el); }
    el.querySelector('span').textContent = txt; el.classList.add('show'); clearTimeout(el._t); el._t = setTimeout(function () { el.classList.remove('show'); }, 1500);
  }
  var shownTotal = null;
  function reduced() { try { return matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; } }
  function paintTotal(el, to) {
    if (!el) return;
    var from = (shownTotal === null) ? to : shownTotal; shownTotal = to;
    if (from === to || reduced()) { el.textContent = money(to); return; }
    var t0 = performance.now(), d = Math.min(420, Math.max(200, Math.abs(to - from) / 200));
    (function f(now) { var k = Math.min(1, (now - t0) / d); k = 1 - Math.pow(1 - k, 3); el.textContent = money(Math.round(from + (to - from) * k)); if (k < 1) requestAnimationFrame(f); })(t0);
    /* rAF is paused in background tabs: land on the final value by timer regardless */
    setTimeout(function () { if (shownTotal === to) el.textContent = money(to); }, d + 60);
    el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
    var btn = findAtcButton(); if (btn) { btn.classList.remove('bump'); void btn.offsetWidth; btn.classList.add('bump'); }
  }

  /* ---- rows (variant A) ---- */
  function rowGlasses(st, gp) {
    var shot = glassesShot();
    return '<div class="tkc-r fixed"><span class="tkc-th">' + (shot ? '<img src="' + shot + '" alt="">' : '') + '</span>' +
      '<span class="tkc-t"><b>' + esc(glassesName(st)) + '</b><span>' + esc(glassesSub(st)) + '</span></span>' +
      '<span class="tkc-pr"><b>' + (gp ? money(gp * productQty()) : '') + '</b></span></div>';
  }
  function kitBox(kit, gp) {
    var on = (choice === 'kit' || choice === 'rx'), isRx = (choice === 'rx');
    var unit = isRx ? kitCents(krx(kit), kit.rxNum) : kitCents(kv(kit), kit.num);
    var cmp = isRx ? kitCompareCents(krx(kit), kit.rxWas) : kitCompareCents(kv(kit), kit.was);
    var delta = unit - (gp || 0);
    var hasRx = rxPurchasable(kit);
    var rxDelta = hasRx ? kitCents(krx(kit), kit.rxNum) - kitCents(kv(kit), kit.num) : 0;
    var thumbs = isRx ? [RX.img].concat(kit.thumbs.filter(function (t) { return t !== IMG.nose; })) : kit.thumbs;
    var parts = thumbs.map(partInfo);
    var desc = L.plus + parts.map(function (x, i) { return i ? lower1x(x.name) : x.name; }).join(', ');
    var hasLens = thumbs.some(function (t) { return t === IMG.blue || t === IMG.gold || t === IMG.purple || t === IMG.hc; });
    return '<button type="button" class="tkc-up' + (on ? ' is-on' : '') + '" data-tkc="kit" role="switch" aria-checked="' + on + '">' +
      '<span class="tkc-sw"></span><span class="tkc-th"><img src="' + thumbs[0] + '" alt=""></span>' +
      '<span class="tkc-t"><b>' + L.upgrade + esc(kit.title) + '</b><span>' + esc(desc) + '</span></span>' +
      '<span class="tkc-pr"><b>' + (delta >= 0 ? '+' : '') + money(delta) + '</b>' + (cmp > unit ? '<i>' + L.save + ' ' + money(cmp - unit) + '</i>' : '') + '</span>' +
      '<span class="tkc-kit">' + thumbs.map(function (t, i) {
          return '<span class="tkc-kr"><span><img src="' + t + '" alt="" loading="lazy"></span><em><b>' + esc(parts[i].name) + '</b><i>' + esc(parts[i].why) + '</i></em></span>'; }).join('') +
        (hasLens ? '<span class="tkc-why">' + L.why + '</span>' : '') +
        (cmp > unit ? '<span class="tkc-sep"><span>' + L.sep + '</span><b>' + money(cmp) + '</b></span>' : '') +
        (hasRx ? '<label class="tkc-rx"><input type="checkbox" data-tkc-rx' + (isRx ? ' checked' : '') + '><span>' + (kit.thumbs.indexOf(IMG.nose) >= 0 ? L.rx : L.rxAdd) + '<small>' + L.rxHow + '</small></span><b>' + (rxDelta > 0 ? '+' + money(rxDelta) : '') + '</b></label>' : '') +
      '</span></button>';
  }
  function rowAdded(o) {   /* {key, img, title, sub, cents, orig, edit?, fresh} */
    return '<div class="tkc-r' + (o.fresh ? ' enter' : '') + '" data-added="' + esc(o.key) + '">' +
      '<span class="tkc-th">' + (o.img ? '<img src="' + o.img + '" alt="">' : '') + '</span>' +
      '<span class="tkc-t"><b>' + esc(o.title) + '</b><span>' + esc(o.sub) + '</span><span class="tkc-act">' +
        (o.edit ? '<button type="button" data-edit>' + L.edit + '</button>' : '') + (o.noRemove ? '' : '<button type="button" data-rm>' + L.remove + '</button>') + '</span></span>' +
      '<span class="tkc-pr"><b>+' + money(o.cents) + '</b>' + (o.orig > o.cents ? '<s>' + money(o.orig) + '</s>' : '') + '</span></div>';
  }
  function hasDrawer() {
    try { return typeof window.openAddonDrawer === 'function' && !!document.querySelector('[data-addon-drawer]'); } catch (e) { return false; }
  }
  function addButtons(st) {
    /* the spare-lens and accessory buttons open the theme's own drawer; on a page
       without one (The Clip) they would be dead, so leave them out entirely */
    if (!hasDrawer()) return '';
    var fromTxt = LENSMIN ? (L.from + money(LENSMIN)) : '';
    var sharp = /Sharp/i.test(st.lens || '');
    return '<div class="tkc-add">' +
      '<button type="button" data-tkc-dn="lenses"><span><b>+ ' + L.lensT + '</b><i>' + L.lensBtnD + (fromTxt ? ' · ' + fromTxt : '') + '</i></span><u>&rsaquo;</u></button>' +
      '<button type="button" data-tkc-dn="accessories"><span><b>+ ' + L.accT + '</b><i>' + (sharp ? L.accDSharp : L.accD) + '</i></span><u>&rsaquo;</u></button></div>';
  }
  var seenAdded = {};
  var lastSize = null;
  function addedRows(stNow) {
    var out = '', sel = themeSel(), sa = themeAddons();
    lensEntries().forEach(function (e) {
      var k = e.key, fresh = !seenAdded[k]; seenAdded[k] = 1;
      out += rowAdded({ key: k, img: e.img ? imgUrl(e.img, 120) : '', title: L.lensRow, sub: e.label, cents: e.price, orig: e.orig || 0, edit: false, fresh: fresh });
      if (e.mirror && typeof e.mirror.cents === 'number') {
        var km = k + ':mir', fm = !seenAdded[km]; seenAdded[km] = 1;
        var mid = (e.items.filter(function (it) { return isMirrorId(it.id); })[0] || {}).id, mi = mid ? mirrorInfo(mid) : null;
        out += rowAdded({ key: km, img: mi ? mi.img : (e.mirror.image ? imgUrl(e.mirror.image, 120) : ''), title: mi ? mi.name : (e.mirror.name || L.mirrorRow), sub: mirrorFitText(stNow, true), cents: e.mirror.cents, orig: 0, fresh: fm, noRemove: true });
      }
      if (e.nosepad && typeof e.nosepad.cents === 'number') {
        var kn = k + ':np', fn = !seenAdded[kn]; seenAdded[kn] = 1;
        var insId = (e.items.filter(function (it) { return isInsertId(it.id); })[0] || {}).id;
        var npId = (e.items.filter(function (it) { return nosepadVariant(it.id); })[0] || {}).id, npi = npId ? nosepadInfo(npId) : null;
        var isIns = !!insId || /insert|innsats|prescription|styrke/i.test(e.nosepad.name || '');
        var npSub = isIns ? (insId && INSERT[String(insId)] ? INSERT[String(insId)][1] + ' · ' + INSERT[String(insId)][0] : (e.nosepad.name || '')) : (npi ? npi.color : (e.nosepad.name || ''));
        out += rowAdded({ key: kn, img: npi && npi.img ? npi.img : (e.nosepad.image ? imgUrl(e.nosepad.image, 120) : ''), title: isIns ? L.insertRow : L.nosepadRow, sub: npSub, cents: e.nosepad.cents, orig: 0, fresh: fn });
      }
    });
    for (var i = 0; i < sa.length; i++) {
      var a = sa[i], ka = 'acc:' + a.variantId, fa = !seenAdded[ka]; seenAdded[ka] = 1;
      var c = cardFor(a.variantId), im = c && c.querySelector('img');
      var q = Math.max(1, parseInt(a.quantity, 10) || 1);
      var insA = isInsertId(a.variantId), mirA = isMirrorId(a.variantId) ? mirrorInfo(a.variantId) : null;
      out += rowAdded({ key: ka, img: mirA ? mirA.img : (im ? im.currentSrc || im.src : ''), title: (mirA ? mirA.name : insA ? L.insertRow : (a.title || L.accRow)) + (q > 1 ? ' × ' + q : ''), sub: mirA ? mirrorFitText(stNow, false) : insA ? (INSERT[String(a.variantId)][1] + ' · ' + INSERT[String(a.variantId)][0]) : (a.variantInfo || ''), cents: (a.currentCents || a.price || 0) * q, orig: (a.originalCents || 0) * q, fresh: fa });
    }
    return out;
  }
  function totalsNow(gp) {
    if (current && (choice === 'kit' || choice === 'rx')) { var kt = kitTotals(); return { total: kt.total, save: kt.save }; }
    var x = extrasCents(); return { total: (gp || 0) * productQty() + x.cur, save: Math.max(0, x.orig - x.cur) };
  }

  /* ---- chooser (six lenses) ---- */
  var chooserOpen = false, chooserPick = 0, chooserLarge = false;
  function sixPriced(st) { var six = sixLenses(st); if (lensEntries().length > 0 || kitOn()) six = six.map(function (x) { var y = {}; for (var k in x) y[k] = x[k]; y.pctFirst = y.pct; y.price = y.orig; y.pct = 0; return y; }); return six; }
  function chooserHtml(st) {
    var six = sixPriced(st), side = sideOf(st.mirror), size = sizeStr(st.size), extra = lensEntries().length > 0;
    if (!six.length) return '';
    if (chooserPick >= six.length) chooserPick = 0;
    var o = six[chooserPick], mirV = (o.gen === 'orig' && o.kind !== 'W/O') ? largeMirror(side) : null;
    var addP = o.price + (mirV && chooserLarge ? mirV.price : 0);
    return '<div class="tkc-ch" data-tkc-ch>' +
      '<h4>' + L.chooseH + esc(st.lens) + '</h4>' +
      '<p class="tkc-sz">' + L.sizeLine1 + '<b>' + (size === '140' ? 'S · 140' : 'M · 145') + '</b>' + L.sizeLine2 + '</p>' +
      '<div class="tkc-opts">' + six.map(function (x, i) {
        return '<button type="button" class="tkc-o' + (i === chooserPick ? ' sel' : '') + '" data-pick="' + i + '"><div><img src="' + x.img + '" alt="" loading="lazy"></div>' +
          '<em class="' + x.gen + '">' + (x.gen === 'sharp' ? L.sharpTag : L.orig) + '</em><b>' + esc(x.tint.replace(/ Sharp$/, '')) + '</b><span>' + sideLabel(x.kind) + '</span>' +
          '<span class="pp">' + (x.orig > x.price ? '<s>' + money(x.orig) + '</s>' : '') + money(x.price) + '</span></button>'; }).join('') + '</div>' +
      '<div class="tkc-mir"><span class="t">' + L.mirT + '</span>' +
        (mirV ? '<span class="tkc-ms"><button type="button" data-mir="med" class="' + (chooserLarge ? '' : 'on') + '">' + L.mirMed + '<i>' + L.mirInc + '</i></button>' +
                '<button type="button" data-mir="large" class="' + (chooserLarge ? 'on' : '') + '">' + L.mirLarge + '<i>+' + money(mirV.price) + '</i></button></span>'
              : '<span class="tkc-mt">' + (o.kind === 'W/O' ? L.mirNone : (o.gen === 'sharp' ? L.mirSharp : L.mirDual)) + '</span>') +
      '</div>' +
      (extra && !kitOn() ? '<p class="tkc-note">' + L.oneDisc + '</p>' : '') +
      '<button type="button" class="tkc-all" data-tkc-all>' + L.seeAll + ' &rsaquo;</button>' +
      '<div class="tkc-f"><button type="button" data-tkc-cancel>' + L.cancel + '</button><button type="button" class="pri" data-tkc-add>' + L.addLens + ' · ' + money(addP) + '</button></div></div>';
  }
  function openThemeDrawer(cat) {
    track('tri_kit_downsell_open', { category: cat, kit: current ? current.key : '' });
    try { if (typeof window.openAddonDrawer === 'function') window.openAddonDrawer(cat); } catch (err) {}
    setTimeout(function () { try { var d = document.querySelector('[data-addon-drawer]'), o = document.querySelector('[data-addon-overlay]'); if (d && d.style.display === 'flex' && !d.classList.contains('is-open')) { d.classList.add('is-open'); if (o) o.classList.add('is-open'); } } catch (e2) {} }, 120);
  }

  function render() {
    var st = readState();
    var kit = matchKit(st);
    var el = document.getElementById('tri-kit-complete');
    /* The View anchors on its "Make it yours" block. The Clip page has no such
       block, so fall back to the add-to-cart block and sit just above it. */
    var anchor = document.querySelector('.addon-categories');
    var beforeAnchor = true;
    if (!anchor) {
      anchor = document.querySelector('.product__block__buttons') ||
               (document.querySelector('form[action*="/cart/add"]') || {}).parentNode || null;
    }
    if (!anchor || !st) { if (!document.getElementById('tri-kit-complete')) document.documentElement.classList.remove('tkc-hide-addons'); return; }
    var h4 = anchor.previousElementSibling; if (h4 && h4.tagName === 'H4' && !h4.id) h4.id = 'tkc-miy-title';
    /* Log exposure once the kit question is actually settled: with on-demand
       kit fetching the first render can happen before the matching kit's price
       is in, and logging then would report shown:false for a kit we do offer. */
    if (!exposureLogged) {
      var rule = kitRule(st);
      if (pricesLoaded && (!rule || PRICES[rule.variant])) {
        exposureLogged = true;
        if (!PREVIEW) track('tri_kit_module_exposure', { shown: !!kit, kit: kit ? kit.key : '', lens: st.lens, color: st.color, mirror: st.mirror, size: st.size });
      }
    }
    ensureCss();
    document.documentElement.classList.add('tkc-hide-addons');
    if (!el) { el = document.createElement('div'); el.id = 'tri-kit-complete'; anchor.parentNode.insertBefore(el, anchor); }
    if (!kit) { current = null; if (choice !== 'glasses') choice = 'glasses'; }
    else { var kitChanged = !current || current.key !== kit.key; current = kit; if (choice === 'rx' && !rxPurchasable(kit)) choice = 'kit'; }
    syncEntriesFromTheme();
    /* v15.4: kit toggled on/off → the lens rows (and the theme drawer's preview) follow.
       v15.5: the drawer's price preview shows the discount only while NO spare lens is in the package yet —
       the cart discounts one lens per pair, so a second lens is always full price. */
    window.__tkcNoLensDisc = kitOn() || lensEntries().length > 0;
    try { document.documentElement.classList.toggle('tkc-no-lens-disc', !!window.__tkcNoLensDisc); } catch (e) {}   /* v15.6: hides the drawer's «−30 %» group pill + promo line */
    if (!window.__tkcRepricing) {
      window.__tkcRepricing = true;
      try {
        var es = lensEntries();
        if (es.length) {
          var before = es.map(function (e) { return e.price; }).join(',');
          repriceEntries(es);
          if (before !== es.map(function (e) { return e.price; }).join(',')) { rebuildThemeSel(es); lastEntries = es; themeUpdate(); }
        }
      } catch (e) {}
      window.__tkcRepricing = false;
    }
    /* spare lenses and accessories are size-specific: a size change empties them */
    if (lastSize !== null && st.size !== lastSize && !window.__tkcClearing) {
      var had = lensEntries().length || themeAddons().length;
      if (had) {
        window.__tkcClearing = true;
        try {
          window._lensPickerSelection = null; seenAdded = {}; lastEntries = [];
          [].slice.call(document.querySelectorAll('.addon-card.active')).forEach(function (c) { c.classList.remove('active'); });
          try { if (typeof syncSelectedAddons === 'function') syncSelectedAddons(); } catch (e) {}
          themeUpdate(); toast(L.sizeCleared);
        } catch (e) {}
        window.__tkcClearing = false;
      }
    }
    lastSize = st.size;
    if (!window.__tkcFixing) { window.__tkcFixing = true; try { if (fixInsertColour(st)) themeUpdate(); } catch (e) {} window.__tkcFixing = false; }
    var gp = glassesPrice();
    var tt = totalsNow(gp);
    var addedHtml = addedRows(st);
    var n = 1 + (addedHtml.match(/data-added=/g) || []).length + ((choice === 'kit' || choice === 'rx') && kit ? kit.thumbs.length : 0);
    el.innerHTML = '<p class="tkc-h"><b>' + L.head + '</b><small>' + n + ' ' + (n === 1 ? L.part : L.parts) + '</small></p>' +
      '<div class="tkc-list">' + rowGlasses(st, gp) + addedHtml + '</div>' +
      (kit ? kitBox(kit, gp) : '') + addButtons(st) +
      '<div class="tkc-tot"><span>' + L.total + (tt.save > 0 ? '<span class="sv">' + L.youSave + ' ' + money(tt.save) + '</span>' : '') + '</span><b data-tkc-total>' + money(tt.total) + '</b></div>' +
      (chooserOpen ? chooserHtml(st) : '');
    paintTotal(el.querySelector('[data-tkc-total]'), tt.total);
    /* kit row */
    var kr = el.querySelector('[data-tkc="kit"]');
    if (kr) {
      kr.addEventListener('click', function (ev) {
        /* 2026-09-26: the whole Rx row toggles Rx in one tap. Before, a tap on the label
           turned the kit on and re-rendered, so the browser's own label activation hit a
           detached checkbox: Rx never switched on until the second tap (Clarity dead clicks). */
        if (ev.target.closest && ev.target.closest('.tkc-rx')) {
          ev.preventDefault();
          choice = (choice === 'rx') ? 'kit' : 'rx';
          track('tri_kit_match_select', { kit: kit.key, choice: choice });
          render(); setAtcLabel(); return;
        }
        var on = (choice === 'kit' || choice === 'rx');
        /* removing the upgrade must be deliberate: only the switch itself turns it off.
           A click anywhere in the box still turns it on. */
        if (on && !(ev.target.closest && ev.target.closest('.tkc-sw'))) return;
        choice = on ? 'glasses' : 'kit';
        track('tri_kit_match_select', { kit: kit.key, choice: choice });
        render(); setAtcLabel(); toast(on ? L.kitOff : L.kitOn);
      });
      /* Rx checkbox: handled by the row click above (2026-09-26) */
    }
    /* link rows */
    var ll = el.querySelector('[data-tkc-dn="lenses"]');
    if (ll) ll.addEventListener('click', function () { chooserOpen = false; openThemeDrawer('lenses'); });
    var al = el.querySelector('[data-tkc-dn="accessories"]');
    if (al) al.addEventListener('click', function () { openThemeDrawer('accessories'); });
    /* added rows */
    [].slice.call(el.querySelectorAll('[data-added]')).forEach(function (r) {
      var key = r.getAttribute('data-added');
      var rm = r.querySelector('[data-rm]'), ed = r.querySelector('[data-edit]');
      if (rm) rm.addEventListener('click', function () { if (key.indexOf('acc:') === 0) removeAddon(key.slice(4)); else if (/:np$/.test(key)) removeNosepadEntry(key); else removeLensEntry(key); });
      if (ed) ed.addEventListener('click', function () { chooserOpen = true; render(); });
    });
    /* chooser */
    var ch = el.querySelector('[data-tkc-ch]');
    if (ch) {
      var patch = function () {   /* re-render ONLY the chooser: module, scroll and selection stay put */
        var fresh = document.createElement('div'); fresh.innerHTML = chooserHtml(st);
        var nu = fresh.firstElementChild; if (!nu) { chooserOpen = false; render(); return; } ch.replaceWith(nu); ch = nu; wire();
      };
      var wire = function () {
        [].slice.call(ch.querySelectorAll('[data-pick]')).forEach(function (b) { b.addEventListener('click', function () { chooserPick = parseInt(b.dataset.pick, 10) || 0; chooserLarge = false; patch(); }); });
        [].slice.call(ch.querySelectorAll('[data-mir]')).forEach(function (b) { b.addEventListener('click', function () { chooserLarge = b.dataset.mir === 'large'; patch(); }); });
        ch.querySelector('[data-tkc-all]').addEventListener('click', function () { chooserOpen = false; render(); openThemeDrawer('lenses'); });
        ch.querySelector('[data-tkc-cancel]').addEventListener('click', function () { chooserOpen = false; render(); });
        ch.querySelector('[data-tkc-add]').addEventListener('click', function () {
          var six = sixPriced(st), o = six[chooserPick]; if (!o) return;
          var side = sideOf(st.mirror), mirV = (o.gen === 'orig' && o.kind !== 'W/O' && chooserLarge) ? largeMirror(side) : null;
          track('tri_kit_lens_pick', { tint: o.tint, kind: o.kind, large: !!mirV, extra: lensEntries().length, kit: current ? current.key : '' });
          chooserOpen = false; chooserLarge = false;
          selectLens(o, mirV, side);
          render(); setAtcLabel();
        });
      };
      wire();
    }
    if (kit && !seen[kit.key]) { seen[kit.key] = 1; track('tri_kit_match_view', { kit: kit.key }); }
    if (kit && kitChanged) setAtcLabel();
  }

  function hook() {
    var orig = window.updateConfig;
    if (typeof orig !== 'function') { setTimeout(hook, 400); return; }
    if (orig.__tkmWrapped) return;
    var wrapped = function () {
      var r = orig.apply(this, arguments);
      try { render(); setAtcLabel(); } catch (e) {}
      return r;
    };
    wrapped.__tkmWrapped = true;
    window.__tkcOrigUpdateConfig = orig;
    window.updateConfig = wrapped;
    loadPrices();
    try { render(); setAtcLabel(); } catch (e) {}
  }
  initGroup(startModule);
})();
